export const h = {
	meta: {
		home: {
			title: "wire China 2026 | 12th International Wire & Cable Exhibition, Shanghai",
			keywords: "wire China, wire and cable exhibition, cable trade show China, wire cable expo, international wire cable fair, Shanghai cable exhibition, wire harness exhibition, connector exhibition, cable machinery, cable materials, wire China 2026, exhibit at wire China, wire China exhibitor, wire China visitor registration, SNIEC Shanghai",
			description: "wire China 2026 — the 12th International Wire & Cable Exhibition, Sept 21-24, 2026, SNIEC Shanghai. Asia's leading trade fair for wire, cable, harness, connectors and materials. Connect with global exhibitors and buyers, join summit forums. Book a booth or pre-register free.",
			ogTitle: "wire China 2026 | 12th International Wire & Cable Exhibition",
			ogDescription: "Asia's leading wire & cable trade fair · Sept 21-24, 2026 · SNIEC Shanghai",
			ogType: "event",
			ogUrl: "https://www.wirechina.net",
			ogSiteName: "wire China 2026"
		},
		about: {
			title: "About wire China | China International Wire & Cable Industry Exhibition Overview",
			keywords: "about wire China, wire China exhibition overview, 12th cable exhibition, Asia cable exhibition, international wire & cable exhibition, Messe Düsseldorf, Shanghai Electric Cable Research Institute, wire China history, wire China organizers",
			description: "About wire China: the China International Wire & Cable Industry Exhibition is one of the most influential industry events in Asia and worldwide, co-hosted by Shanghai Electric Cable Research Institute Co., Ltd. and Messe Düsseldorf (Shanghai) Co., Ltd. The exhibition is dedicated to presenting the latest products, technologies and solutions to the industry."
		},
		media: {
			title: "Cooperative Media | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China cooperative media, cable industry media partners, cable exhibition press, wire and cable media, cable industry news partners, wire China media cooperation",
			description: "wire China 2026 cooperative media section — gathering official media partners and industry/daily press that cooperate with the China International Wire & Cable Industry Exhibition, building bridges for industry information dissemination and corporate brand exposure."
		},
		dynamic: {
			title: "Exhibition News | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China exhibition news, cable industry information, wire and cable industry news, cable exhibition news, exhibitor updates, exhibition news report, industry trends, cable exhibition news",
			description: "wire China 2026 exhibition news page — officially publishing news, exhibitor updates, industry information and technology trend analysis of the 12th China International Wire & Cable Industry Exhibition. It is the primary entry to track the progress of the show."
		},
		transport: {
			title: "Transportation and Accommodation | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "Shanghai New International Expo Center transportation, Longyang Road metro station, Shanghai Pudong airport, Shanghai Hongqiao railway station, cable exhibition hotel, wire China traffic guide, exhibition hotel, Pudong accommodation",
			description: "wire China 2026 transportation and accommodation guide — providing metro, bus and driving routes to Shanghai New International Expo Center (No. 2345 Longyang Road, Pudong) as well as recommended hotels during the show, to help exhibitors and visitors plan their trip."
		},
		zsLogin: {
			title: "Exhibitor Login | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China exhibitor login, exhibitor login entry, exhibitor account login, exhibitor password login, booth management login, exhibitor backend login, cable exhibition exhibitor entry",
			description: "wire China 2026 exhibitor login entry — registered exhibitors can log in to the exhibitor center with account/password/verification code to manage booth materials, promotional items, badges and the exhibiting workflow."
		},
		zsCenter: {
			title: "Exhibitor Center | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China exhibitor center, exhibitor backend, booth management, exhibiting progress, exhibitor services, exhibitor material management, exhibitor badge application, booth confirmation",
			description: "wire China 2026 exhibitor center — a single entry that provides exhibitors with booth progress inquiry, promotional material submission, exhibitor badge application, exhibitor manual download, customer invitation registration and other full exhibitor services."
		},
		zwApply: {
			title: "Booth Application | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China booth application, 2026 cable exhibition booth booking, cable exhibition booth reservation, booth quotation, exhibitor application, wire China recruitment hotline, cable exhibition booth booking",
			description: "wire China 2026 booth application entry — the booth recruitment page of the 12th China International Wire & Cable Industry Exhibition, supporting exhibitors to submit booth applications online, view the booth plan and learn booth quotation and recruitment progress."
		},
		czProcess: {
			title: "Exhibiting Procedure | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China exhibiting procedure, cable exhibition exhibiting steps, booth application process, exhibitor guide, recruitment process, exhibitor manual, wire China exhibiting steps",
			description: "wire China 2026 exhibiting procedure — from booth application, contract signing, document submission, personnel registration to on-site setup and teardown, presenting the complete exhibiting process of the 12th China International Wire & Cable Industry Exhibition."
		},
		zsPropagateApply: {
			title: "Exhibitor Promotion Application | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China exhibitor promotion, exhibition promotion slots application, exhibitor branding, exhibitor advertising slots, onsite material distribution, exhibitor promotion service, wire China value-added services",
			description: "wire China 2026 exhibitor promotion application entry — providing exhibitors with an online channel to apply for value-added promotion services such as on-site advertising slots, conference sponsorship, onsite material distribution and brand co-promotion."
		},
		vistorRegister: {
			title: "Visitor Registration | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China visitor registration, 2026 cable exhibition visitor pre-registration, free visitor badge, cable exhibition visitor signup, wire and cable visitor pre-registration, visitor pass application",
			description: "wire China 2026 visitor registration / pre-registration entry — complete the online pre-registration in advance to obtain a free visitor badge, skip the on-site queue and enjoy fast entry and free exhibition materials."
		},
		vistorRegisterCgt: {
			title: "Group Registration | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China group visit, group visitor registration, group visit application, group visit, VIP visitor benefits, group visit, cable exhibition group visit, team registration",
			description: "wire China 2026 group registration entry — register as a group with 5 or more people and enjoy VIP visitor benefits: free catalogs, dedicated channels, group photos and bus drop-off passes."
		},
		vistorCgtCenter: {
			title: "Group Center | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China group center, team management, member information, group data download, group benefits, group visitor backend, group status inquiry",
			description: "wire China 2026 group center — group leaders can log in to manage group members, view group review progress, download exclusive group materials and enjoy group VIP benefits."
		},
		vistorRegisterGz: {
			title: "Visitor Registration (Guangzhou) | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China Guangzhou visitor registration, Guangzhou cable exhibition visitor pre-registration, Guangzhou wire and cable exhibition visitor pass, Greater Bay Area cable exhibition, southern China cable industry visitor signup",
			description: "wire China 2026 Guangzhou visitor registration — convenient for industry visitors from the Greater Bay Area and South China to complete pre-registration locally, with pre-registration vouchers valid for visitor badge collection onsite in Shanghai or at authorized pickup points in South China."
		},
		meetIndustryConference: {
			title: "Industry Conference | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China industry conference, China wire and cable industry conference, cable industry association conference, China Electrical Equipment Industry Association Wire & Cable Branch, cable industry summit forum",
			description: "wire China 2026 industry conference — the China wire & cable industry conference series held concurrently with the 12th China International Wire & Cable Industry Exhibition, jointly organized by China Electrical Equipment Industry Association Wire & Cable Branch and Shanghai Electric Cable Research Institute Co., Ltd."
		},
		meetTechnicalExchange: {
			title: "Technical Exchange | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China technical exchange, cable technical forum, cable technical seminar, high-voltage cable insulation, green low carbon cable, new energy cable technology, 5G communication sea cable, cable technology innovation",
			description: "wire China 2026 technical exchange — closely following current hot trends such as high-voltage cables, green low carbon, intelligent equipment, new energy cables and 5G communication sea cables, inviting well-known cable industry enterprises and senior experts to share the latest products and technologies."
		},
		meetOverseasExhibition: {
			title: "Overseas Exhibition | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "overseas wire and cable exhibition, international cable exhibition, Philippines cable exhibition, Germany wire and cable exhibition, Vietnam cable exhibition, Indonesia cable exhibition, wire Düsseldorf, cable companies going overseas",
			description: "wire China 2026 overseas exhibition section — integrating the organizers' flagship international cable exhibitions (including wire Düsseldorf) to help Chinese cable enterprises learn about global industry exhibitions and develop overseas markets."
		},
		meetCableCloud: {
			title: "Cable Cloud Club | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "Cable Cloud Club WICE, Shanghai Electric Cable Research Institute Co., Ltd., State Key Laboratory of Special Cable Technology, China Electrical Equipment Industry Association Wire & Cable Branch, cable technology online exchange",
			description: "wire China 2026 Cable Cloud Club (WICE) — jointly organized by State Key Laboratory of Special Cable Technology, China Electrical Equipment Industry Association Wire & Cable Branch and Shanghai Electric Cable Research Institute Co., Ltd., providing online technical sharing and dissemination for the cable industry."
		},
		meetOther: {
			title: "Other Meetings and Events | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China concurrent events, themed forums, industry salons, awards ceremonies, themed visit routes, cable industry exchange events",
			description: "wire China 2026 other concurrent meetings and events — including themed forums, industry salons, awards ceremonies and themed visit routes, providing exhibitors and visitors with more diverse on-site exchange opportunities."
		},
		productSupplier: {
			title: "Featured Products (Exhibitor) | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China featured products, exhibitor exhibits, cable exhibition exhibitor list, cable equipment manufacturers, wire and cable production equipment, finished wire and cable products, special cables",
			description: "wire China 2026 featured products (exhibitor perspective) — an overview of exhibitor products for buyers, covering the entire industry chain: wire manufacturing and finishing machinery, auxiliary processing, raw materials, finished wire and cable, measurement & control and testing engineering."
		},
		productSupplierDetail: {
			title: "Exhibitor Product Details | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "exhibitor product details, wire and cable product details, cable exhibition product page, cable product specs, cable product application, exhibitor product introduction",
			description: "wire China 2026 exhibitor product details page — showing specific products offered by exhibitors including model, specifications, application scenarios and contact information, helping buyers gain in-depth understanding and contact exhibitors."
		},
		productProduceDetail: {
			title: "Production Equipment Details | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "cable production equipment details, wire drawing machine, stranding machine, cabling machine, cable extruder, cable equipment specs, cable equipment manufacturers",
			description: "wire China 2026 production equipment details page — providing detailed information on cable production equipment such as wire drawing machines, stranding machines, cabling machines and extruders, including model, performance, technical parameters and the corresponding manufacturers."
		},
		productAskToBuy: {
			title: "Post Purchasing Needs | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "cable purchasing needs, wire and cable purchasing, wire and cable procurement, cable procurement demands, cable product inquiry, wire China purchasing post",
			description: "wire China 2026 purchasing needs posting page — buyers can post sourcing requirements for wire and cable, equipment and raw materials online, and the system intelligently matches them with the exhibitor database and forwards them to relevant exhibitors, improving docking efficiency."
		},
		productHome: {
			title: "Featured Products (Buyer) | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China featured products buyer, buyer zone, wire and cable procurement, cable equipment procurement, raw materials procurement, cable procurement platform",
			description: "wire China 2026 featured products buyer zone — a product overview for buyers, aggregated by category including wire manufacturing and finishing machinery, auxiliary processing, raw materials, special wire and cable, measurement & control and testing engineering."
		},
		ProRecList: {
			title: "Recommended Products | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "recommended products, wire and cable recommendation, cable exhibition hot exhibits, featured products, exhibitor picks, new arrivals",
			description: "wire China 2026 recommended products page — curating the leading brand exhibitors and new products that attract buyer attention in this edition of the show, highlighting high-quality and specialized cable products."
		},
		ExhibitorRecommendation: {
			title: "Recommended Exhibitors | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "recommended exhibitors, wire and cable preferred exhibitors, wire China quality exhibitors, well-known cable companies, branded cable exhibitors, cable industry leading exhibitors",
			description: "wire China 2026 recommended exhibitors page — curating leading cable brands, well-known manufacturing enterprises and key exhibitors for buyers and professional visitors, providing quick access to premium cooperation partners."
		},
		PopularVideos: {
			title: "Popular Videos | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China popular videos, exhibitor videos, cable product videos, exhibition highlights, cable process videos, exhibition live replay",
			description: "wire China 2026 popular videos — collecting exhibitor promo videos, product demonstrations, exhibition highlights and live replays, presenting the latest cable industry technology and on-site moments from multiple angles."
		},
		productRelease: {
			title: "Release Products | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China product release, exhibitor new products, cable new product launch, wire China new arrivals, exhibitor product upload",
			description: "wire China 2026 product release entry — exhibitors can submit new product or technology information online, which will be displayed in the exhibition new product zone after review, increasing product exposure and matching efficiency."
		},
		vistorCenter: {
			title: "Visitor Center | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China visitor center, visitor backend, visitor pass management, visitor reservation, favorites exhibitors, visitor material download",
			description: "wire China 2026 visitor center — pre-registered visitors can log in to manage visitor passes, reserve exhibitors of interest, favorite exhibits, and download exhibition materials."
		},
		vistorLogin: {
			title: "Visitor Login | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China visitor login, visitor pass account login, visitor backend login, visitor pre-registration account",
			description: "wire China 2026 visitor login entry — pre-registered visitors can log in to the visitor center via mobile, email or visitor pass number to view reservations and personalized content."
		},
		visaApply: {
			title: "Visa Application | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "China visa application, cable exhibition visa invitation letter, wire China invitation letter, international visitor visa, exhibition visa, travel visa, visa application guide",
			description: "wire China 2026 visa application service — providing international visitors with a visa invitation letter, visa application guide and FAQs, helping cross-border visitors obtain a visa smoothly."
		},
		share: {
			title: "Share and Promote | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China share and promote, exhibition invitation letter sharing, cable exhibition social sharing, exhibitor invitation poster, promotional code sharing",
			description: "wire China 2026 share and promote page — exhibitors and visitors can generate exclusive invitation links, QR codes or posters to invite peers to visit together, track invitation results and earn extra benefits."
		},
		resourceCenter: {
			title: "Resource Center | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China resource center, exhibitor manual download, visitor manual download, exhibition catalog, post-show report, catalog download, exhibition materials",
			description: "wire China 2026 resource center — providing a single download entry for official materials such as invitation letters, hall maps, exhibitor manuals, visitor guides, electronic catalogs and post-show reports."
		},

		czsList: {
			title: "Exhibitor List | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "2026 wire and cable exhibition, China International Wire & Cable Industry Exhibition, cable exhibition information, wire and cable exhibition, Shanghai New International Expo Center, exhibitor list, wire China exhibitors, cable industry exhibitor directory",
			description: "wire China 2026 exhibitor list — gathering all participating enterprises of the 12th China International Wire & Cable Industry Exhibition, covering the entire cable industry chain: wire manufacturing and finishing machinery, auxiliary processing, raw materials, finished wire & cable, measurement and control technology, testing engineering."
		},
		vistorMaterials: {
			title: "Visitor Materials Download | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China materials download, exhibition catalog, post-show report, exhibitor list, exhibition preview, cable exhibition materials, cable exhibition materials download, exhibitor list download, invitation letter download, visitor guide download",
			description: "wire China 2026 visitor materials download center — providing a single download entry for exhibition invitation letters, hall maps, exhibitor lists, electronic catalogs and post-show reports."
		},
		vistorCgtteamapply: {
			title: "Group Visit Application | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "group visit registration, group application, group visitors, VIP visitor benefits, group visit, cable exhibition group, cable exhibition group visit, team registration, group visit, cable industry group",
			description: "wire China 2026 group visit application entry — register a group with 5 or more people to enjoy VIP visitor benefits: fast pass for visitor badge, free catalogs, group photo and bus drop-off pass."
		},
		vistorCgtLogin: {
			title: "Group Login | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "group login, group visitor login, team account, cable exhibition group login, team visitor login, cable exhibition group visitors",
			description: "wire China 2026 group login entry — group visitors can log in to the group center via account and password to manage member information and group benefits."
		},
		factory: {
			title: "Factory Open Day | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China factory open day, factory visit, wire and cable factory, cable manufacturing factory, factory in-depth visit, cable manufacturing process, cable factory tour, wire China Factory Day, factory immersive visit",
			description: "wire China 2026 factory open day — taking industry peers into SAMP and Yi Teng Electric and other quality cable manufacturing enterprises for on-site visits to production lines, technical processes and overall strength, building in-depth trust and cooperation."
		},
		dynamicDetail: {
			title: "Exhibition News Detail | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China news, cable industry information, exhibition news details, cable industry news, wire and cable industry information, cable industry news, industry news report",
			description: "wire China 2026 exhibition news detail — sharing exhibition news, exhibitor updates, cable industry information and technology trend analysis, providing authoritative information on the cable industry."
		},
		search: {
			title: "Search | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China search, cable exhibition exhibitor search, product search, purchase information search, exhibition news search, cable exhibition search, cable product search",
			description: "wire China 2026 search center — providing a unified search function for exhibitors, products, purchase information, exhibition news, exhibition materials and other content types."
		},
		videoPreview: {
			title: "Video Preview | wire China 2026 The 12th China International Wire & Cable Industry Exhibition",
			keywords: "wire China video trailer, exhibition promotional video, cable exhibition live preview, wire China video highlights, cable exhibition video, exhibition VCR, exhibitor video",
			description: "wire China 2026 video preview page — presenting the exhibition official promotional video, exhibitor highlights, live broadcast previews and wonderful review videos of previous exhibitions."
		},
		keno: {
			title: "Keno AI Assistant | Wire China 2026",
			keywords: "Keno AI assistant, wire China intelligent assistant, AI cable industry assistant, exhibition intelligent Q&A, keno AI, cable industry AI assistant",
			description: "Keno AI assistant — officially launched by wire China as an AI intelligent assistant for the cable industry, able to quickly answer questions about the wire China 2026 exhibition, exhibitors, exhibits and the cable industry."
		},
	},
	total: "Total",
	record: "Records",
	require: {
		select: "Please select",
	},
	tips: "Tips",
	    factoryDay: {
	      mainTitle: "Step into material innovation，embrace the power of smart manufacturing",
	      subTitle: "Step into material innovation，embrace the power of smart manufacturing",
	      overview: "In 2026，wire China \"Factory Open House\" will further advance this concept, extending the communication scenario from exhibition booths to the frontlines of factory production. Participants will conduct on-site inspections, engage in face-to-face discussions with company executives and technical experts, and build in-depth trust through immersive experiences, laying a solid foundation for follow-up cooperation.",
	      overview1: "Focusing on in-depth supply-demand matching, wire China 2026 Factory Open Day will arrange exclusive in-depth visit itineraries, enabling participants to:",
	      overview2: "Following the event, we will continue to provide ongoing business matching and follow-up services, driving the conversion of intent into tangible cooperation.",
		  visitCompanies: "This tour will visit:",
	      sampDesc: "SAMP(Changzhou) Co., Ltd. - Showcasing vertically integrated manufacturing processes for complete Wire and Cable production lines",
	      yitengDesc: "Changzhou Yi Teng Electric Co., Ltd. - Innovating with premium copper alloy conductors to deliver cutting-edge solutions and advanced products",
	      highlightsTitle: "Factory Tour Highlights",
	      highlight1Title: "1. Dive into Production Frontlines",
	      highlight1Content: "Visit the full production process from raw materials to finished products on-site, and gain an intuitive understanding of production capacity, material quality, craftsmanship standards and quality control systems.",
	      highlight2Title: "2. Spark Technical Inspiration",
	      highlight2Content: "Engage in in-depth communication with senior R&D and production teams, discuss manufacturing procedures and technical challenges face to face, and inspire innovative ideas through efficient dialogue.",
	      highlight3Title: "3. Build Partnership & Trust",
	      highlight3Content: "Connect with corporate decision-makers and core operation teams, witness the overall strength of the enterprise in person, and build partnership trust efficiently.",
	      highlight4Title: "4. Expand Business Network",
	      highlight4Content: "Connect with high-quality partners across the manufacturing chain, find reliable suppliers and strong manufacturing partners, and unlock new opportunities for business growth.",
		  routeTitle:"Routes",
		  route1Title:"Route A: Smart Equipment",
		  route1Content:"Smart equipment and digital production line construction, empowering efficient production through technological innovation.",
		  route2Title:"Route B：Advanced Material",
		  route2Content:"R&D and application of halogen-free, low-smoke, environmentally friendly flame-retardant, and high-performance modified materials.",
		  route3Title:"Route B：Industry Chain Collaboration Route",
		  route3Content:"A core cluster of China’s cable industry, and one of the largest wire & cable manufacturing bases with a complete industrial chain and full product ranges nationwide. ",
		  serviceTitle:"Comprehensive Services",
		  service1Title:"1. Service Guarantee",
		  service1Content:"We provide one-stop itinerary arrangement and on-site coordination services, including transportation, guided tours and interpretation. Insurance will also be purchased for all participants.",
		  service2Title:"2. Exclusive Accompaniment",
		  service2Content:"A dedicated stuff will accompany participants throughout the event to promptly respond to any needs.",
		  noticeTitle:"Important Notes",
		  notice1Title:"Registration",
		  notice1Content:"Spots are limited. Registration is subject to review. Approved participants will be notified by phone, SMS, or email.",
		  notice2Title:"Event Fee",
		  notice2Content:"100 EUR per person for overseas participants, invited guests enjoy complimentary access.  (The fee covers transportation, meals, insurance on the event day)",
		  notice3Title:"Registration Deadline",
		  notice3Content:"Friday, September 4, 2026",
		  notice4Content:"Pay to: Shanghai Electric Cable Research Institute Co., Ltd.\nBeneficiary bank: BANK OF COMMUNICATIONS, CO. LTD. NO.99 ZHONG SHAN SOUTH ROAD SHANGHAI CHINA\nAccount number: 310066535010149007975\nSWIFT/BIC: COMMCNSHSHI",
		  
		  factoryPhotos: "Factory Photos",
	      factoryIntroTitle: "What You'll Experience",
	      sampTitle: "SAMP(Changzhou) Co., Ltd.",
	      sampIntro: "Founded in 1936 in Bologna(Italy), SAMP has gradually grown to become the company worldwide able to provide customers with the complete wire and cable process chain. As the core strategic layout of the headquarters in the Asia Pacific region, its Changzhou factory is not only a benchmark for technology and production capacity, but also embodies the deep integration of local innovation and global standards.",
	      sampProducts: "The range of machinery produced by SAMP includes rod breakdown lines for copper, aluminium and alloys, single-wire and multi-wire drawing machines, wire annealers, spooling and coiling solutions, double-twist bunching machines, pay-off solutions, as well as insulation and sheathing lines for every cable manufacturing need, from telecom, LAN or coaxial cables to cables for transport, construction, electronics, signalling and power.",
	      sampAdvantage: "All wire and cable manufacturing machines and lines by SAMP guarantee high productivity, incredible flexibility and great savings in terms of energy and material consumption when compared to other solutions available on the market.",
	      yitengTitle: "Changzhou Yi Teng Electric Co., Ltd.",
	      yitengIntro: "Changzhou Yi Teng Electric Co., Ltd. was founded in July 2014. After years of development, it has now established two modern production bases in Changzhou and Jiangxi, forming a large-scale and efficient production system.",
		  yitengProducts: "The company's business extensively covers core fields such as automotive, medical, robotics, industrial equipment, and aerospace, with a focus on the research, development and production of new copper alloy material conductors. Among them, copper-clad steel conductors and various high-performance copper alloy conductors are the core flagship products. With excellent electrical conductivity, mechanical strength and stability, they have set a technical benchmark in the industry.",
		  yitengAdvantage: "Relying on its superior product quality and technical strength, the company has established and maintained long-term and stable cooperative relationships with world-renowned wire harness enterprises such as Leoni, Coficab, Proterial, Sumitomo, LTK, and KBE, continuously providing reliable material solutions for various industries.",
	      registrationTitle: "For inquiries & registration",
	      contactInfo: "For any inquiries, please contact:",
      contactPerson: "Contact Person",
      contactName: "Ms. Helen Wang",
      email: "Email",
      tel: "Tel",
	  registerBtn: "Sign up",
	  routeTourTitle: "Immersive Factory Tours (Choose One)",
	  route1Title: "Route 1: Smart Equipment Route",
	  route1CompanyLabel: "Company to Visit:",
	  route1Company: "ZTT Digital Industry Group",
	  route1HighlightsLabel: "Highlights:",
	  route1Highlights: "A focus on smart equipment and digital production line construction, empowering efficient production through technological innovation.",
	  route1Desc: 'ZTT Digital Industry Group adheres to the philosophy of "integrating hardware and software into systems, advancing toward an unmanned and intelligent future." With forward-looking strategic positioning in artificial intelligence, intelligent robotics, healthcare, drones, and other emerging fields, the company drives the incubation and industrialization of new quality productive forces through technological breakthroughs. Its goal is to become a regional and industry benchmark for AI and smart manufacturing, continuously empowering digital transformation in partnership with clients and supply chain collaborators.',
	  route2Title: "Route 2: Industry Chain Collaboration Route",
	  route2CompaniesLabel: "Companies to Visit:",
	  route2Companies: "Wuxi Zhongding Electric Machinery Co., Ltd.\nFar East New Materials Co., Ltd.",
	  route2HighlightsLabel: "Highlights:",
	  route2Highlights: "A deep dive into the core cluster of China's cable industry, visiting benchmark enterprises in equipment manufacturing and new material R&D.",
	  zhongdingTitle: "Wuxi Zhongding Electric Machinery Co., Ltd.",
	  zhongdingDesc: "Wuxi Zhongding Electric Machinery Co., Ltd. is a high-tech enterprise integrating R&D, design, and manufacturing of specialized wire and cable equipment. Its main products include high-speed extruders, taping machines, stranding machines, and other cable machinery. The company has its own technical research division, the Wuxi Zhongding High-Speed Cable Equipment Engineering Technology Research Center. This center has brought in a team of high-caliber professionals and also actively collaborates with universities on industry-academia-research projects. It focuses on independent R&D in cable equipment, consistently introducing a range of specialized machinery with strong proprietary intellectual property and a high degree of automation.",
	  farEastTitle: "Far East New Materials Co., Ltd.",
	  farEastDesc: "Far East New Materials Co., Ltd. is a wholly-owned subsidiary of Far East Shareholding Company. Equipped with advanced domestic and international production facilities, including 12 state-of-the-art production lines, the company achieves an annual production and sales scale of RMB 600 million. It is dedicated to the R&D and production of advanced polymer materials for cables, with major product lines including PVC insulation compounds, PVC sheath compounds, PVC flame-retardant compounds; 10–35kV peroxide-crosslinked XLPE insulation compounds; 10kV and below silane-crosslinked XLPE insulation and overhead compounds; and low-smoke halogen-free flame-retardant cable sheath and insulation compounds."
	    },
	home: {
		h1: "wire China 2026 | 12th China International Wire & Cable Exhibition ",
		box1: {
			label1: "square",
			content1: "Exhibition area",
			label2: "people",
			content2: "Professional visitor",
			label3: "home",
			content3: "Well-known exhibitor",
			label4: "field",
			content4: "Thematic exchange",
		},
		box2: {
			title: "",
			content:
				"With over 20 years of experience, wire China has grown into one of the most influential trade fairs for wire and cable industry in the world. As the organizers of wire China, Messe Düsseldorf (Shanghai) Co., Ltd. and Shanghai Electric Cable Research Institute Co., Ltd., will actively carry out the coming works for the exhibition and present a high-quality trade fair for wire and cable industry. In the four-day exhibition, industry leading brands from Mainland China as well as overseas countries will participate. ",
			btn1: "Show Information",
			btn2: "Floor Map",
			btn3: "Show Report",
			btn4: "2026 Exhibitor List",
		},
		box3: {
			title: "Exhibition News",
		},
		box4: {
			label1: "Learn more",
			label2: "details",
			label3: "See more",
		},
		box5: {
			title: "Exhibitor Presentation",
			tab1: "Digital & Innvoative",
			tab2: "Technology Tools",
			tab3: "Green & Low-carbon",
			tab4: "Wires & Cables",
			tab5: "Measuring & Technology",
		},
	},
	about: {
		btn1: "Basic info",
		btn2: "Exhibits & Visitors",
		btn3: "Previous overview",
		btn4: "Contact us",
		box1: {
			content:
				"wire China was founded in 2004, every two years, has grown into Asia's leading cable and wire industry exhibition. The organizers, Shanghai Cable Research Institute Co., Ltd. and Messe Dusseldorf (Shanghai) Co., LTD., give full play to their respective advantages, bring together high-quality exhibitors and buyers from around the world, promote industry exchanges and information sharing, and present the latest products, technologies and solutions in the industry from a professional perspective.",
			date: "Opening Hours:\n              21-23, Sept 09:00-17:00\n              24, Sept 09:00-15:00",
			addressLabel: "Venue:    ",
			addressValue: "Shanghai New International Expo Center",
			title: "Organizer",
			listTitle1: "Shanghai Electric Cable Research Institute Co., Ltd.",
			listContent1:
				"Shanghai Electric Cable Research Institute Co.,Ltd. is the only research institution in China that integrates wire and cable R&D, engineering design, testing, information exhibition service and industry work. Mainly engaged in all kinds of bare cable, overhead wire, rubber and plastic insulated electrical equipment wire and cable, high voltage/ultra high voltage wire and cable, communication cable, optical brazing cable, building structure bearing cable and other products and accessories research and development and testing; Research and development of various conductors, insulation and sheathing materials for wire and cable; Research, design and production of wire and cable equipment and testing instruments; Design and contract related factories and engineering projects; Test wire and cable products and accessories; Entrusted by the state and local, wire and cable products quality certification. In addition, it is also engaged in the technical centring work of domestic wire and cable and special equipment standards and the manufacturing of special wire and cable, and is the focal point of the 4 technical committees (TC) and 2 sub-technical committees (SC) of the National Electrotechnical Commission (IEC).",
			listTitle2: "Messe Düsseldorf (Shanghai) Co., Ltd.",
			listContent2:
				"Messe Düsseldorf (Shanghai) Co.,Ltd. founded in 2009, is a subsidiary of Messe Düsseldorf Group, a world-renowned exhibition organizer in China. With a well-established marketing and service network, Messe Düsseldorf is committed to bringing world-class professional exhibitions to China and providing personalized and high-quality services for the Chinese market and customers. Since its establishment, after years of innovative development, the company has successfully created 13 first exhibition brands and conferences in China and even Asia in the printing, packaging, wire and cable and pipe, plastics, medical devices, retail, safety production and occupational health, wine and spirits, RV and other industries. At present, the company is headquartered in Shanghai, with an office in Beijing, and has more than 70 regular employees.",
			web: "View official website",
		},
		box2: {
			title1: "Range of exhibits ",
			listLabelNew1: "Measurement and Control Technology",
			listLabelNew2: "Testing Engineering",
			listLabelNew3: "Other Related Fields",
			listLabel1: "Wire and Cable Manufacturing and Finishing Machinery",
			listLabel2: "Cable auxiliary Machining",
			listLabel3: "Raw and Auxiliary Materials for Cables (Optical Cables)",
			listLabel4: "Finished Wire and Wire Cable",
			listLabel5: "Spring Manufacturing Equipment and Technology",
			listLabel6: "Fastener Manufacturing Equipment and Technology",
			listLabel7: "Measurement and Control Technology",
			listLabel8: "Inspection Engineering",
			listLabel9: "Related Field",
			title2: "Source of visitors",
			btn1: "Electric / Optical Fiber Cable Industry",
			btn2: "Wire Industry",
			btn3: "Iron Steel / Non-Ferrous Metal Industry",
			btn4: "Chemical Industry",
			btn5: "Automotive Supply Industry",
			btn6: "Electronic Industry",
			btn7: "Electrical Industry",
			btn8: "Instrumentation Testing & Measuring",
			btn9: "Fastener Industry",
			btn10: "Energy / Water supply Industry",
			btn11: "IT / Telecommurncation",
			btn12: "Construction Industry",
			btn13: "Aerospace Engineering",
			btn14: "Others",
			btn15: "",
		},
		box3: {
			title1: "Previous overview",
			content1:
				'As Asia\'s first-class cable and wire industry event, wire China 2023 presents new technologies, new products and new concepts in the industry in all aspects, and jointly seizes the development opportunities of digitalization, intelligence and greening with enterprises, helping the industry to embark on a new journey of "accelerating"!\n' +
				'              <span class="emphasize"> 40,629 </span>professional visitors from<span class="emphasize"> 96 </span>countries and regions, an increase of<span class="emphasize"> 30.83%</span>over 2018\n' +
				'              More than<span class="emphasize"> 900 </span>cable and wire industry brand exhibitors from<span class="emphasize"> 19 </span>countries and regions\n' +
				'              <span class="emphasize">57,500 </span>square meters of professional exhibition platform\n' +
				'              <span class="emphasize">2 </span>major industry conferences, <span class="emphasize">4 </span>theme forums, <span class="emphasize">40+ </span>theme exchanges to provide future breakthroughs\n' +
				'              <span class="emphasize">5 </span>major theme routes for precise and efficient immersive exhibition',
			title2:
				"The World’s Largest Professional Wire & Cable Exhibition of the Year",
			content2:
				"Wire China brings together more than 900 exhibitors from 19 countries and regions, including national and regional pavilions from Germany, France, Italy, South Korea, Japan and Taiwan, China. Industry leaders choose Wire China as a platform for promoting innovative technologies and launching new products. The exhibition attracts wire and cable manufacturing and finishing machinery, cable auxiliary processing, raw and auxiliary materials for cables (optical cables), finished wires and wires, measurement and control technology, testing engineering and other related fields, bringing high-quality exhibition and visiting experience to wire and cable colleagues.",
			title3:
				"Top Enterprises from Home and Abroad Gather Together",
			content3:
				"Overseas buyers have returned in full force, with a total of 40,629 professional visitors attending the exhibition, a record high, including many overseas buyers from 96 countries and regions including the United States, Canada, Australia, Germany, the United Kingdom, Italy, Spain, France, Japan, South Korea, Singapore, Brazil, India, Thailand, Vietnam, Argentina, etc. Wire China 2023 attracted the attention of global cable people, fully demonstrated the latest development trends and innovative technological achievements of the cable industry, provided an excellent stage for fully demonstrating the industry's surging vitality and vitality, and received great praise and recognition from professional visitors.",
			title4: "Visitors' Industry",
			content4:
				"Cable industry\n" +
				"Wire industry\n" +
				"Chemical industry\n" +
				"Testing equipment and technology\n" +
				"Construction industry\n" +
				"Electronics industry\n" +
				"Motor and electrical industry\n" +
				"Energy industry\n" +
				"Steel and non-ferrous metal industry\n" +
				"Aerospace engineering\n" +
				"Information technology and telecommunications industry\n" +
				"Oil and gas industry\n" +
				"Pipe industry\n" +
				"Automobile manufacturing industry",
			title5:
				"2 major industry conferences, 40+ topic sharing, creating an industry thought leader",
			content5:
				'Focusing on hot trends such as "intelligent manufacturing", "green and low-carbon", "digital innovation" and "sustainable development", wire China has worked closely with government agencies, industry associations and financial institutions to launch dozens of professional forums/conferences to create business opportunities and build bridges for cooperation for global industry colleagues.\n' +
				"\n" +
				"-2023 China Wire and Cable Industry Conference\n" +
				"-2023 Winding Wire Industry Technology Forum\n" +
				"-Cable Technology Exchange Meeting\n" +
				"\n" +
				"The Industrial Economics Sub-Forum, Green and Low-Carbon Sub-Forum, Intelligent Manufacturing Sub-Forum and Digital Innovation Sub-Forum took turns to appear, and well-known industry companies and senior experts spoke on the same stage.",
			footerText1: "Review of ",
			footerText2: "last session",
			reviewOfLastSession: "Review of last session"
		},
		box4: {
			title1: "Exhibition contact",
			title2: "Visit Contact/business matchmaking",
			title3: "Media liaison",
		},
	},
	dynamic: {
		btn1: "Exhibition Latest",
		btn2: "Industry Focus",
		btn3: "Newsletter Archive",
		label: "See more",
	},
	tran: {
		btn1: "Traffic",
		btn2: "Hotel",
		title:
			"In order to facilitate your travel to the exhibition hall, the organizers have provided you with a variety of convenient transportation methods",
		content:
			'As the first-class cable and wire industry event in Asia, wireChina 2024 exhibition presents a full range of new technologies, new products and new concepts in the industry, and jointly grasp the digital, intelligent and green development opportunities with enterprises to help the industry open a new journey of "accelerating"!',
		addressLabel: "Location: ",
		addressValue: "2345 Longyang Road, Pudong New Area, Shanghai",
		title2: "How to get there",
		box1: {
			title: "Private car",
			content1:
				"Shanghai New International Expo Center is located at the intersection of Longyang Road and Luoshan Road, and can be reached directly from the city center across Nanpu Bridge and Yangpu Bridge. During the exhibition period: Parking space is sufficient at Gate 7 of Shanghai New International Expo Center (side of Huamu Road). Parking fee: RMB 8 per hour, RMB 64 per day, this rate applies to cars or other light vehicles",
			content2: "Self-driving restriction Notice:",
			content3:
				"Shanghai external elevated (expressway) restrictions: Monday to Friday 7:00--20:00 (except weekends and national holidays); Shanghai outer ring road restrictions: Monday to Friday 7:00-9:00, 17:00-19:00 (except weekends and national holidays)",
		},
		box2: {
			title: "Taxi",
			content1:
				"Take a taxi to Shanghai New International Expo Center 1 South Entrance Hall /3 East Entrance Hall.",
		},
		box3: {
			title: "Subway",
			content1:
				"Shanghai New International Expo Center, Subway Line 7 - Huamu Road station can reach SNIEC.",
			content2:
				"No matter where you start from, you can transfer to Metro Line 7 at the following stops:",
			content3: "Metro Line 1 - Changshu Road Station subway",
			content4: "Line 2 - Jing 'an Temple Station subway",
			content5:
				"Line 3 / Metro Line 4 - Zhenping Road Station Metro Line 4 - Dongan Road Station Shanghai Metro Line map (available)",
		},
		box4: {
			title: "Train",
			content1: "From Shanghai Railway Station",
			content2:
				"Taxi: about 17 km away; About 30 minutes; The fare is about 60 yuan;",
			content3:
				"Subway: Take Line 1 to People's Square Station or Line 4 to Century Avenue Station, transfer to Line 2 to Longyang Road Station, walk or transfer to Line 7 to the Hall 2 North Entrance hall; About 50 minutes; The fare is 4 yuan.",
			content4: "Depart from Shanghai South Railway Station",
			content5:
				"Taxi: about 20 km away; About 30 minutes, the fare is about 70 yuan;",
			content6:
				"Subway: Take Line 1 to People's Square Station, transfer to Line 2 to Longyang Road Station, walk or transfer to Line 7 to the Hall 2 North entrance hall; About 55 minutes; The fare is 5 yuan.",
		},
		box5: {
			title: "Aeroplane",
			content1:
				"Shanghai New International Expo Center is located between Shanghai Pudong International Airport and Shanghai Hongqiao International Airport, about 32 km from Pudong International Airport in the east and 27 km from Hongqiao International Airport in the west. It can be easily reached by maglev train, subway, airport bus or taxi.",
			content2: "From Shanghai Pudong International Airport: about 35 minutes;",
			content3: "From Shanghai Hongqiao Airport: About 35 minutes.",
			content4: "Taxi: about 35 minutes (via airport expressway);",
			content5: "The fare is about 120 yuan;",
			content6:
				"Maglev train: only 8 minutes; RMB 50 one-way (if you show your ticket or use your Shanghai Transit card, RMB 40 one-way;",
			content7:
				"80 yuan round trip; By bus: Take Airport Line 5 to Longyang Road Station, walk or transfer to Line 7 to the North entrance Hall of Pavilion 2;",
			content8: "About 50 minutes; The fare is 16 yuan;",
		},
		hotelColunm1: "Hotel Name",
		hotelColunm2: "Star Level",
		hotelColunm3: "Hotel Address",
		hotelColunm4: "Price/Yuan (including double morning)",
		hotelColunm5: "Shuttle service during the exhibition",
		hotelColunm6: "Distance exhibition hall",
	},
	exApply: {
		title1: "Marketing Service",
		label1:
			"In order to provide each exhibitor with a better exhibition experience, the organizers of wire China will promote the exhibitors' highlight exhibits through the official platforms of the exhibition such as WeChat public accounts, official websites, video accounts, etc., to help exhibitors seize the buyers' attention in advance and warm up for the exhibition site.",
		label2: "Application requirements",
		label3:
			"Exhibitors participating in the promotion need to provide corporate pictures and other materials.",
		label4: "Click",
		label5: "Submit promotional materials",
		label6: "Edit and publish after confirmation by the organizer。",
		title2: "Exhibition contact",
	},
	visaApply: {
		title1: "Visa application",
		label1:
			"All foreigners are required to hold a visa when entering China. We recommend that you apply for a visa one month before your departure from your home country.",
		title2: "invitation letter",
		label2:
			"All visa applicants must hold an invitation letter issued by an authorized agency in China. We will send your information to the authorized agency in China, and the authorized agency will issue a formal business invitation letter and send it to your company by email within 5 days. At the same time, the applicant must provide a clear copy of the passport, a copy of the front and back of the credit card, the hotel confirmation form and the itinerary in China.",
		title3: "Remark",
		label3:
			"The passport must be valid for at least six months beyond the intended date of entry into China.",
		title4: "Click to register",
	},
	headerLogin1: "Exhibitor Center",
	headerLogin2: "Visitor Login",
	headerSearch: "Search",
	headerLanguage1: "中文",
	headerLanguage2: "EN",
	headerLanguage3: "日本語",
	headerLanguage4: "한국어",
	headerLanguage5: "ไทย",
	headerLanguage6: "EN",
	footerCompanyName1: "Shanghai Electric Cable Research Institute Co.,Ltd.",
	footerCompanyName2: "Messe Düsseldorf (Shanghai) Co., Ltd.",
	footerLabel1: "Shanghai",
	footerLabel2: "wire Worldwide",
	footerLabel3Germany: "Germany",
	footerLabel3Eurasia: "Eurasia",
	footerLabel3Mexico: "Mexico",
	footerLabel3Thailand: "Thailand",
	footerLabel3India: "India",
	footerLabel3MEA: "MEA",
	footerLabel4: "WeChat",
	footerLabel5: "@wiretradefair",
	footerLabel6: "Newsletter Subscription",
	footerLabel7: "Get latest news",
	footerLabel8: "Shanghai Electric Cable Research Institute Co. Ltd. Shanghai,",
	footerLabel8Icp: "ICP. 13014242-3",
	footerLabel8Suffix: "",
	languageChangeLoading: "Switching Languages...",
	tabName1: "Home",
	tabName2: "INFO",
	tabName2Item1: "About wire China",
	tabName2Item2: "Ex Map",
	tabName2Item3: "Exhibition News",
	tabName2Item4: "Partner Media",
	tabName2Item5: "Transportation",
	tabName2Item6: "Exhibition Overview",
	tabName2Item7: "Exhibitor Service",
	tabName2Item8: "Cooperative Media",
	tabName3: "Exhibitor",
	tabName3Item1: "Exhibiting Procedure",
	tabName3Item2: "Exhibitor List",
	tabName3Item3: "Booth Application",
	tabName3Item4: "Marketing Service",
	tabName3Item5: "Exhibitor Center",
	tabName3Item6: "",
	tabName3Item7: "Exhibitor Center",
	tabName4: "Visitor",
	tabName4Item1: "Visitor Registration",
	tabName4ItemItem1: "Visitor Pre-Registeration",
	tabName4Item2: "Download",
	tabName4Item3: "Featured Exhibits",
	tabName4Item4: "Visitor Login",
	tabName4Item5: "Visa Application",
	tabName4Item6: "Visitor Center",
	tabName5: "Events",
	tabName5Item1: "Industry Conference",
	tabName5Item2: "Technical Seminars",
	tabName5Item3: "WICE",
	tabName5Item4: "Overseas Exhibitions",
	tabName5Item5: "Other Meets & Events",
	tabName6: "e-SHOW",
	tabName6Item1: "Exhibitor",
	tabName6Item2: "Exhibit",
	tabName6Item3: "Sourcing Requests",
	tabName6Item4: "Post Sourcing Requests",
	tabName7: "Factory Tour",
	tabName7Item1: "Registration",
	tabResourceCenter: "Resource center",
	registerBox: {
		label1: "Individual Registration",
		label2: "Book online now",
		label3: "Group Registration",
		label4: "Book online now for group",
		label5: "Exhibition contact",
	},
	registerGroup: {
		title: "Group Pre-registration",
		title1: "Introduction of the visiting group",
		label1:
			"In addition to individual Tours, we also offer group Tours. Covers from wire and cable industry, steel and non-ferrous metal industry, automotive industry and aerospace industry, electrical industry, construction industry, professional trade and other related industry associations and enterprises. In order to avoid the complicated registration procedures and enjoy the visiting privileges, wire China now invites industry associations and enterprises to organize a group visit.",
		label2: "Grouping requirement",
		label3: "1.Number of persons: 10 or more;",
		label4: "2.Deadline for registration: August 15, 2026",
		label5:
			"3.After submitting the group information, the group can be formed only after being confirmed by the organizer.",
		label6: "Group visit, enjoy the VIP audience!",
		label7: "1.Get your visitor pass quickly",
		label8: "2.Free visit guide and electronic journal",
		label9: "3.Group viewing gift pack",
		label10: "4.Take a group photo",
		label11: "5.Temporary bus disembarkation permit",
		label12: "Click to download",
		label13: "wire China 2026 Group Visit Application form",
		label14:
			",complete the form and send it to the Organizer's contact person as required (email to vivian.huang@mds.cn).",
		label15: "For more information, please download: ",
	},
	vistorRegister: {
		btn: "next",
		title1: "Verificate",
		title1Box: {
			label1: "Already a member？",
			label2: "Return login",
			label3:
				"Thank you for your attention and support to THE 12TH ALL CHINA - INTERNATIONAL WIRE & CABLE INDUSTRY TRADE FAIR!",
			label6span1: "If you have 10 or more visitors, please click",
			label6span2: " here ",
			label6span3: "apply for group.",
			label6span4: "Viewers in Hong Kong, Macao, Taiwan, and overseas regions",
			label6span5: "Registration",
			label7:
				"Please note that the pre-registeration entrance will be closed at 12:00 Beijing time on September 20, 2026.",
			label8: "If you are unable to register, please call 021-6169 8317.",
		},
		title2: "Write",
		title2Box: {
			title1:
				"The information filled in will be used for the exhibition official website, wechat invitation promotion channels.",
			label1: "Name",
			holder1: "Please enter your name",
			label2: "Gender",
			holder2: "Please select gender",
			label3: "Id number",
			holder3: "Please enter your ID number",
			label4: "Department",
			holder4: "Please enter department",
			label5: "Position",
			holder5: "Please select a position",
			label6: "Country and region",
			holder6: "Please select country and region",
			label7: "Company name",
			holder7: "Please enter the company name",
			label8: "Telephone",
			holder8: "Please enter telephone",
			label9: "Website",
			holder9: "Please enter the website",
			label10: "Postcode",
			holder10: "Please enter postcode",
			label11: "Email",
			holder11: "Please enter email",
			label12: "Detailed address",
			holder12: "Please enter the full address",
			label13: "Mobile",
			holder13: "Please enter your mobile number",
			holder13Header: "Area code",
			label14: "Be present or not",
			holder14: "Please choose whether to attend",
			holder15: "The detailed address must be at least 10 characters long",
			holder16: "Please enter the correct mobile number",
			holder17: "Please enter the correct email address",
			holder18: "Please enter the correct postcode",
			yes: "Yes",
			no: "No",
		},
		title3: "Question",
		title3Box: {
			holder1: "The industry to which your products belong.",
			holder2: "The nature of the company's business.",
			holder3:
				"Your purpose of participating in the exhibition (multiple selection).",
			holder4:
				"How do you get the information about this exhibition (multiple selections).",
			holder5:
				"What exhibits do you expect to see at this week's exhibition (choose more)",
			otherholder15: "15 Otherwise, fill in the description",
			otherholder24: "24 Otherwise, fill in the description",
			otherholder33: "33 Otherwise, fill in the description",
			otherholder45: "45 Please enter exhibitor name",
		},
		title4: "Complete",
		title4Box: {
			apply_success: "apply successfully",
			label1: "Registered successfully",
			label2: "Dear",
			douhao: ",",
			maohao: ":",
			label3:
				"Thank you for your attention and support to wireChina! Visit the site with your ID card.",
			label4: "Group visit of 10 people or more:",
			label5: "Enjoy VIP privileges, group visit more convenient!",
			btn1: "Pick up electronic visitor pass",
			btn2: "Go to visitor center",
			label6: "Pre-register number",
			label7: "VISITOR",
			label8:
				"Group visit of 10 people or more: Enjoy the VIP privileges immediately!",
			label9: "Grouping condition",
			label10: "Number of persons: 10 and above",
			label11:
				"Industries: Wire industry, wire and cable industry, steel and non-ferrous metal industry, automobile industry, aerospace industry, electrical industry, construction industry, professional trade, related industry services, related associations, related universities and institutes, etc",
			label12:
				"*The information of the members must be reviewed by the organizer before the group can be formed",
			label13: "Group visitors can enjoy:",
			label14: "·	Get your visitor pass quickly",
			label15: "·	Free conference brochure",
			label16: "·	Group Exhibition Promotional Materials",
			label17: "·	Audience lounge admission ticket (providing tea drinks, etc.)",
			label18: "",
			label19span1: "Download",
			label19span2: "wire China2023 Group Visit Form",
			label19span3: "Team registration deadline: August 15, 2023.",
			label20: "Q&A",
			label21: "Q1: Opening hours of the exhibition to visitors",
			label22: "September 21–24, 2026 (Monday to Thursday): 09:00–16:30",
			label23: "September 24, 2026 (Thursday): 09:00–14:00",
			label24: "Q2: Exhibition location",
			label25: "Hall E1-E7, Shanghai New International Expo Center",
			label26: "Address: No. 2345 Longyang Road, Pudong New Area, Shanghai",
			label27: "Q3: How to exchange for admission?",
			label28:
				"Shanghai New International Expo Center 1# Entrance Hall, 3# Entrance hall",
			label29:
				'On site with the "electronic visitor card" in exchange for the visitor\'s ID card, enter the visit with the ID card.',
			label30: "Visit contact",
			label31: "Messe Düsseldorf (Shanghai) Co., Ltd.",
			label32: "Ms. Vivian Huang",
			label33: "Tel:",
			label34: " E-mail:",
		},
	},
	vistorCenter: {
		title: "Shanghai Electric Cable Research Institute Co. Ltd.",
		footerTitle: "Logout",
		label1: "Respected",
		label2:
			"Thank you for your attention to THE 12TH ALL CHINA - INTERNATIONAL WIRE & CABLE INDUSTRY TRADE FAIR!",
		label3: "You have successfully registered as a visitor.",
		menuLabel1: "Home",
		menuLabel2: "Personal information",
		menuLabel2Item1: "Electronic visitor pass",
		menuLabel2Item2: "Confirmation of visit",
		menuLabel2Item3: "Modify account information",
		menuLabel2Item4: "Audience questionnaire",
		menuLabel3: "Invitation",
		menuLabel3Item1: "Other's Pre-registration",
		menuLabel3Item2: "Group Visit Service",
		menuLabel3Item3: "Invite Friends",
		menuLabel4: "Business Matching",
		menuLabel4Item1: "My Sourcing Requests",
		menuLabel4Item2: "My consultation",
		menuLabel4Item3: "My Favorites",
		menuLabel5: "Conference activity",
		menuLabel6: "Contact us",
		cardContent1: "Electronic visitor pass",
		cardContent2: "Visiting rights",
		cardContent3: "I post the demand",
		cardContent4: "Suppliers and product collection",
		cardContent5: "Group visit service request",
		cardContent6: "Conference activity",
		hoverContent1:
			'You have successfully registered as a visitor of THE 12th CHINA INTERNATIONAL WIRE AND CABLE INDUSTRY EXHIBITION, and you can directly exchange your visit card with the "pre-registration confirmation letter + business card" on the spot. Visit the site with your ID card.',
		hoverContent2:
			"You have successfully registered THE 12th CHINA INTERNATIONAL WIRE AND CABLE INDUSTRY EXHIBITION. We will bring professional buyers, visitors can not miss the exclusive services and benefits. Click now to view your entitlements.",
		hoverContent3:
			"Register as a wire China viewer, you can post your purchase needs, and check the progress of published purchase needs and business matching at any time.",
		hoverContent4:
			"You can collect exhibits and suppliers of interest, and easily access product information and supplier information.",
		hoverContent5:
			"In addition to individual Tours, we also offer group Tours. Can avoid the complicated on-site registration procedures, and enjoy the privileges of visiting groups.",
		hoverContent6:
			"Based on the forefront of the industry, the organizers carefully organize industry conferences and theme forums, build a platform for exhibitors to release and exchange new products and new technologies, help the industry chain and supply chain to improve the development level, and smooth the positive cycle of the industry and a new path for intelligent development.",
		modal: {
			title: "Warm reminder",
			content: "Please complete the audience questionnaire first",
			btn: "Go to fill out",
		},
	},
	vistorLogin: {
		noAccount: "No account?",
		registerNow: "Register now",
		cgtLoginBtn: "Audience Group Login",
		title: "The 12th China International",
		title2: "Wire and Cable",
		titleSub: "Industry Event",
		loginTitle: "Visitor login",
		loginTitle2: "Exhibitor login",
		loginTitle3: "Audience group login",
		loginForm1: "Account",
		loginForm1Holder: "Please enter your account",
		loginForm2: "Password",
		loginForm2Holder: "Please enter password",
		loginFormType1: "Log in with your mobile number",
		loginFormType2: "Use account password to log in",
		loginForm3: "Mobile",
		loginForm3Holder: "Please enter your mobile",
		loginForm5Holder: "Please enter your phone number in the correct format",
		loginForm6Holder: "Have not registered yet? Please register first!",
		loginForm4: "Verification code",
		loginForm4Holder: "Please enter the verification code",
		loginForm5: "Get code",
		loginForm6: "s after",
		loginBtn: "Login",
		loginText: "Login successful!",
		zsLoginCode: "Login with verification code",
		zsLoginPsw: "Login with password",
	},
	floatingBox: {
		label1: "Contact Us",
		label2: "Booth Application",
		label3: "Visitor Registration",
		label4: "Countdown",
		label5: "Day",
		label6: 'Keno Agent',
	},
	czProcess: {
		title1: "Learn more about the exhibition",
		content1: "Contact the exhibition organizer for booth information",
		title2: "Fill in the Application Form",
		content2:
			"After deciding to participate in the exhibition, fill in the application form, stamp and submit to the organizer, new exhibitors need to provide a copy of the business license.",
		title3: 'Organizer issues "Booth Confirmation and Payment Notice"',
		content3: "Exhibitors pay 50% of the booth fee",
		title4: "The organizer seals and returns the Exhibition Application Form",
		content4: "Booth booking successful",
		title5: "Get exhibitor Center access to enjoy exclusive exhibitor services",
		content5:
			"With your username and password, Enter the exhibitor center to enjoy exhibitor services",
		content5Item1:
			"● Submit company information for the conference catalogue and online promotion",
		content5Item2:
			"● Submit product two points for the Exhibition Preview/Product Highlight Manual)",
		content5Item3: "● Invite VIP visitors online",
		content5Item4: "● Submit company lintel board information",
		content5Item5: "● Submit exhibitor badge information",
		content5Item6: "● Submit booth construction form",
		content5Item7: "● Submit logistics transportation form",
		content5Item8: "● Book on-site advertising",
		content5Item9: "● Download Exhibitor Service Manual Exhibition materials",
		title6: 'The organizer issued "Registration and Exhibition Notice"',
		content6:
			'Register on site (get badge), arrange the exhibition, freight vehicles entering the exhibition hall need to apply for "Waiting card"',
	},
	callingCard: {
		title1: "China mainland brand",
		title2: "China brands outside the mainland",
		company1: "Shanghai Electric Cable Research Institute Co. Ltd.",
		company2: "Messe Dusseldorf （Shanghai） Co. LTD",
		label1: "Phone:",
		label2: "Email:",
		label3: "Mobile:",
		name1: "Ms. Ding Xuan",
		name2: "Ms. Mary Cao",
		name3: "Ms. Helen Wang",
		name4: "Ms. Charlotte Shi / Ms. Vivian Huang",
		name5: "Ms. Lu Yujia",
	},
	registerOthers: {
		searchHolderEn: 'Search by email',
		label3En: 'Email',
		holder3En: 'Please enter email',
		columnHeader3En: 'Email',
		holder13: 'Please enter email',
		holder16: 'Invalid email format',
		holder17: 'Invalid email format',
		searchHolder: "Please enter your mobile phone to search",
		searchHolder1: "Please enter your email address to search",
		btn1: "Search",
		btn2: "Pre-register others",
		btn3: "Return list",
		btn4: "Submit",
		btn5: "View",
		columnHeader1: "Name/Gender",
		columnHeader2: "Pre-register number",
		columnHeader3: "Mobile",
		columnHeader4: "Department",
		columnHeader5: "Position",
		columnHeader6: "Login email",
		columnHeader7: "Id number",
		columnHeader8: "Controls",
		columnHeader9: "Company name",
		label1: "Name",
		holder1: "Please enter your name",
		label2: "Gender",
		holder2: "Please select your gender",
		label3: "Mobile",
		holder3: "Please enter your mobile number",
		label4: "Department",
		holder4: "Please enter your department",
		label5: "Position",
		holder5: "Please enter your position",
		label6: "Login email",
		holder6: "Please enter your login email",
		label7: "Id number",
		holder7: "Please enter your id number",
		label8: "Company name",
		holder8: "Please enter company name"
	},
	visitorEmailInvite: {
		btn1: "Email invitation",
		btn2: "Poster offer",
		btn3: "Add/Batch add email invitations",
		modalTitle:
			"Add/Batch add email invitation (multiple please use; Separate)",
		modalHolder: "Please enter email address, multiple please use; Separate.",
		modalBtn1: "Confirm submission",
		modalBtn2: "Cancel",
		column1: "Email address",
		column2: "Name",
		column3: "Company name",
		column4: "Position",
		column5: "Invitation status",
		error1: "The mailbox format is incorrect",
		error2: "Duplicate data exists in the mailbox. Procedure",
		status1: "Already invited",
		status2: "To be invited",
	},
	boothApply: {
		title1:
			"Please fill in the following basic information, the organizer will contact you in time after receiving.",
		title2:
			"* For companies that have submitted booking information, the organizer will arrange the booth one by one, and there is no need to fill in the booth again.",
		title3: "I have read and agree",
		title4: "Data Protection Regulation",
		title5:
			"and consent to the collection and use of my personal data as outlined in this statement.",
		title6: "Please read and agree to the Data Protection Regulation",
		btn1: "Submit",
		label1: "Gender",
		holder1: "Please select gender",
		label2: "Name",
		holder2: "Please enter your name",
		label3: "Company",
		holder3: "Please enter company name",
		label4: "Department",
		holder4: "Please enter department",
		label5: "Position",
		holder5: "Please select a position",
		label6: "Telephone",
		holder6: "Please enter telephone number",
		label7: "Mobile number",
		holder7: "Please enter mobile number",
		label8: "Email",
		holder8: "Please enter email",
		label9: "Website",
		holder9: "Please enter website",
		label10: "Due Date",
		label11: "Login Password",
		holder11: " Please enter your login password",
		label12: "Confirm password",
		holder12: " Please enter your login password again",
		holder14: " Two inconsistent password entries",
		holder15: " Incorrect mobile number format",
		holder16: " Incorrect email format ",
		labelCountry: "Country",
		holderCountry: "Please enter country"
	},
	ExList: {
		goToUrlTitle1: "Wire China 2024 Invitation Letter",
		goToUrlTitle2: "Wire China 2024 Exhibition Hall Distribution Map",
		goToUrlTitle3: "Wire China 2023 Post-show Report",
		goToUrlTitle4: "wire China 2023 Electronic Conference Catalogue",
		goToUrlTitle5: "wire China 2023 Exhibitor List",
		goToUrlTitle6: "wire China 2022 Exhibitor List",
		goToUrlTitle7: "Theme Route - High-precision Measurement and Control",
		goToUrlTitle8: "Theme Route - High-quality Cables and Wires",
		goToUrlTitle9: "Theme Route - High-energy-saving Materials",
		goToUrlTitle10: "Theme Route - High-performance Auxiliary Processing",
		goToUrlTitle11: "Theme Route - High-efficiency Intelligent Equipment",
		goToUrlTitle12: "wire China 2020 Exhibitor List",
		goToUrlTitle13: "wire China 2018 Exhibitor List",
	},
	GroupVisitServiceRequest: {
		PleaseFillInTheFollowingFormProperly:
			"Please fill in the following form properly",
		AllRequiredFields: "All required fields",
		SendBackByEmail:
			"Please send your request back to may@secri.com. The organizer will confirm your request via email after review.",
		FeedbackDeadline: "Return deadline: August 15, 2025 (Friday)",
		WireChinaGroupVisitApplicationForm:
			"Click to register for group tours immediately",
		VIPAudienceTreatment:
			"Groups of 5 or more: enjoy VIP treatment immediately!",
		GroupConditions: "Group conditions",
		VIPAudienceBenefits: "Audience group visit benefits",
		NumberOfPeople: "Number of people: 5 or more",
		Industry:
			"Industries: Wire industry, wire and cable industry, steel and non-ferrous metal industry, automobile industry, aerospace industry, electrical industry, construction industry, professional trade, related industry services, related associations, related colleges and universities and research institutes, others.",
		MemberInformation:
			"*The group members’ information must be reviewed by the organizer before they can form a group.",
		GroupVisitors: "Group visitors can enjoy",
		VisitorPass: "· Get your visitor pass quickly",
		FreeConferenceBrochure: "· Free conference brochure",
		ExhibitionGiftPack: "· Group Exhibition Promotional Materials",
		GroupPhoto: "· Audience lounge admission ticket (providing tea drinks, etc.)",
		TemporaryDropOffPass: "",
	},
	SupplyAndDemand: {
		TheInformationProvidedWillBeUsedTo:
			"*The information provided will be used on the official website of the exhibition, or on the official WeChat account of the exhibition.",
		AddNewDemandInformation: "Add new demand information",
		AddPurchasingRequirements: "Add Purchasing Requirements",
		SerialNumber: "Serial Number",
		PurchaseDetails: "Purchase Details",
		Type: "Type",
		Operate: "Action",
		Check: "Check",
		Delete: "Delete",
		RequirementDetails: "Requirement Details",
		BackToList: "Back to list",
		WantToPurchase: "I want to purchase (multiple choices)",
		RawMaterials: "Raw materials",
		Equipment: "Equipment",
		Products: "Semi-finished or finished products",
		OtherProductionSolutions: "Other production solutions",
		Details: "Details",
		DetailsPoint: "Please enter the purchase requirements details",
		PurchaseQuantity: " Purchase quantity",
		PurchaseQuantityPoint:
			"Please enter the purchase quantity - the required quantity of materials, machinery or products",
		TypePoint: "Please choose the type",
		Default: "Default",
		Picture: "Picture",
		PicturePoint: "Select Image",
		Submit: "Submit",
		ProcurementType: "Procurement type",
		PlannedPurchaseVolume: "Planned purchase volume",
		ProcurementTarget: "Procurement target",
		PurchaseRequirementsDetails: "Purchase requirements details",
	},
	MyConsultation: {
		ConsultationList: "Consultation List",
		CheckDetails: "Check details",
		Supplier: "Supplier",
		Product: "Product",
		booth:"Booth",
		ConsultationDetails: "Consultation details",
		CompanyInformation: "Company information",
		AddressInformation: "Address information",
		CounterpartyName: "Counterparty name",
		CompanyProfileInformation: "Company profile information",
		ExhibitInformation: "Exhibit information",
		ConsultationRecord: "Consultation record",
		PleaseEnterWhatYouWantToReply: "Please enter what you want to reply",
		Submit: "Submit",
		SerialNumber: "Serial Number",
		Name: "Name",
		Type: "Type",
		ConsultationContent: "Consultation content",
		ConsultationTime: "Consultation time",
		Controls: "Action",
		PleaseEnterWhatYouWantToConsult: "Please enter what you want to consult",
		NoMore: "No more than 200 words",
	},
	Favorites: {
		FavoritesList: "Favorites List",
		SupplierCollection: "Supplier Collection",
		ExhibitsCollection: "Product Collection",
		SerialNumber: "Serial Number",
		SupplierName: "Supplier Name",
		Action: "Action",
		UnCollect: "UnCollect",
		NoData: "NoData",
		RemoveFavorite: "Are you sure you want to cancel the collection?",
	},
	Conference: {
		Conference: "Conference",
		ConferenceName: "Conference Name",
		RegistrationTime: "Registration Time",
		Action: "Action",
		CancelRegistration: "Cancel Registration",
		ConcurrentActivities: "Concurrent Activities",
		CableCloudClub: "Cable Cloud Club",
		OtherMeetingAndEvents: "Other meetings and events",
		AreYouSureYouWantToCancelYourRegistration:
			"Are you sure you want to cancel your registration?",
		ConferenceRegistration: "Conference Registration",
	},
	ProductSupplier: {
		Supplier: "Supplier",
		SupplierList: "Supplier List",
		Product: "Product",
		booth:"Booth",
		ProductList: "Product List",
		Consult: "Consult",
		Share: "Share",
		Collect: "Collect",
		Collected: "Collected",
		PleaseEnterTheContentYouWantToConsult:
			"Please enter the content you want to consult",
		MaximumInput: "* Enter up to 200 characters",
		ExhibitorsExhibits: "Exhibitors Exhibits",
		NewsList: "News List",
		NoMore: "No more than 200 words",
		CompanyProfile: "Company Profile",
		Website: "website",
		Address: "address",
		RecommendedToYou: "Recommended To You",
		PopularCategories: "Search for hot topics",
		SearchByHall: "Search by exhibition hall",
	},
	AskToBuy: {
		SearchResults: "search results",
		Category: "Category",
		ResultsHaveBeenFoundForYou: "{total} results have been found for you",
		BuyerPurchasingInformation: "Buyer's purchasing information",
		BuyersFrom: "Buyers from foreign countries",
		UrgentNeeds: "Urgent Needs",
		ReleaseDate: "release date",
		PurchaseProducts: "purchase products",
		PurchaseDetails: "purchase details",
		Quantity: "quantity",
		Application: "application",
		SuppliersHaveAppliedForMatching: "supplier has applied for matching",
		ContactBuyer: "Contact Buyer",
		PleaseEnterYourContent: "Please enter your content",
		OnlyTheAudienceCanConnect:
			"Only visitors can contact, please log out of exhibitor login first",
		PleaseVisitorLoginFirst: "Please log in as a visitor",
		All: "All",
		RawMaterials: "Raw Materials",
		Equipment: "Equipment",
		SemiFinishedOrFinishedProducts: "Semi-finished or finished products",
		OtherProductionSolutions: "Other Production Solutions",
		classify: {
			all: "All",
			'': "All",
			'1': "Cable and wire production and finishing machinery",
			'2': "Auxiliary processing",
			'3': "Auxiliary processing materials",
			'4': "Materials and special wires and cables",
			'5': "Measurement and Control Technology",
			'6': "Testing Engineering",
			'7': "Related areas"
		},
		results: "results",
		reset: "Reset",
		noData: "No Data",
		confirm: "Confirm Submission",
		cancel: "Cancel",
		maxLength: "No more than 200 characters"
	},
	Release: {
		PublishPurchasingRequirements: "Publish purchasing requirements", // Publish purchasing requirements
		WantToPurchase: "I want to purchase (multiple choices)",
		PleaseSelectThePurchaseType: "Please select the purchase type",
		RawMaterials: "Raw Materials",
		Equipment: "Equipment",
		SemiFinishedOrFinishedProducts: "Semi-finished or finished products",
		OtherProductionSolutions: "Other Production Solutions",
		PersonalContactInformation: "Personal contact information",
		NickName: "Nick Name",
		NickNamePlaceholder: "Please enter a nickname",
		Name: "Name",
		NamePlaceholder: "Please type in your name",
		CompanyName: "Company Name",
		CompanyNamePlaceholder: "Please enter your company name",
		RegionCountry: "Region/Country",
		RegionCountryPlaceholder: "Please enter your country",
		Phone: "Phone",
		PhonePlaceholder: "Please enter the phone number",
		Email: "E-mail",
		EmailPlaceholder: "Please enter your email",
		Agree1:
			"I agree to share my contact information with relevant suppliers for matching.",
		Agree2:
			'I confirm that I have read and understood, and agree to the General Terms and Conditions of [CPS+ Online Matchmaking Platform] Business Matching Service, and confirm that I agree to the collection and use of my personal data as outlined in the "Terms of Use" and "Privacy Policy" of the Adsale Group, including the use and provision of my personal data for direct marketing purposes.',
		Agree3:
			"I have read and agree that since the headquarters of Adsale Group is located in the Hong Kong Special Administrative Region of China, its overseas office employees and third-party services may read or transfer personal information from overseas when necessary for business, etc., and this does not reduce any legitimate rights and interests enjoyed under the Privacy Policy, and will ensure that the same level of protection measures are taken.",
	},
	headSearch: {
		PopularSearches: "Popular Searches",
		PleaseEnterTheContentYouWantToSearch:
			"Please enter the content you want to search",
		PopularSearchProductCategories: "Popular Search Product Categories",
		PleaseLoginAsAudience: "Please log in as an audience",
		PleaseLoginAsExhibitor: "Please log in as an exhibitor",
		YouCanNotPerformThisOperation: "You can't perform this operation",
		NotOpenYet: "Not open yet",
		PleaseLogoutOfAudienceLoginFirst: "Please log out of audience login first",
		PleaseLogoutOfExhibitorLoginFirst:
			"Please log out of exhibitor login first",
		CableAndWireProductionAndFinishingMachinery:
			"Cable and wire production and finishing machinery",
		AuxiliaryProcessing: "Auxiliary processing",
		AuxiliaryProcessingMaterials: "Auxiliary processing materials",
		MaterialsAndSpecialWiresAndCables: "Materials and special wires and cables",
		MeasurementAndControlTechnology: "Measurement and Control Technology",
		TestingEngineering: "Testing Engineering",
		RelatedAreas: "Related areas",
	},
	ExCenter: {
		FrontPage: "Home",
		BasicInformation: "Basic Information",
		CompanyInformation: "Company Information",
		ExhibitInformation: "Product Presentation",
		ExhibitorPromotionApplication: "Exhibitor Press Release",
		BillingInformation: "Billing Information",
		ChangePassword: "Change Password",
		ExhibitorServices: "Exhibitor Services",
		ExhibitorServiceManual: "Exhibitor Service Manual",
		ExhibitorInvite: "Exhibitor Invitation",
		ExhibitorInvitation: "Exhibitor Invitation",
		ConferenceInformation: "Catalogue Information",
		OnlineInvitation: "Online Invitation",
		ExhibitorBadge: "Exhibitor Badge",
		AdvertisingServices: "Advertising Services",
		Down:"Download",
		BusinessSupplyAndDemandDockingManagement:
			"Matchmaking Management",
		MyMatchmakingApplication: "My matchmaking application",
		Consult: "Consult",
		SupplierAndProductCollection: "My Favorite List",
		MyPurchasingNeeds: "Procurement Demand release",
		CompanyName: "Company Name",
		BoothNumber: "Booth Number",
		BoothType: "Booth Type",
		BoothArea: "Booth Area",
		SquareMeter: "sqm",
		ContentToBeFilledIn: "Content to be filled in",
		Deadline: "Deadline",
		FinishedCondition: "Finished Condition",
		NotCompleted: "Not completed (please fill in)",
		ViewTheExhibitorServiceManualOverview:
			"View the Exhibitor Service Manual Overview",
	},
	Company: {
		CompanyInformation: "Company Information",
		CompanyOverview: "Company Overview",
		CompanyName: "Company Name",
		CompanyNameCN: "Company Name in Chinese",
		CompanyNameEN: "Company Name in English",
		BoothNumber: "Booth Number",
		BoothType: "Booth Type",
		BoothRange: "Booth Area",
		ExhibitorClassification: "Main Product Categories",
		CompanyAndProductIntroduction: "Company/product introduction in Chinese",
		CompanyAndProductIntroductionEN: "Company/product introduction in English",
		ProductBrand: "Main Products",
		ApplicationArea: "Application Area",
		CompanyPhone: "Company Phone",
		CompanyFax: "Company Fax",
		CompanyWebsite: "Company Website",
		CompanyAddress: "Company Address",
		RawSpaceBooth: "Raw Space Booth",
		StandardBooth: "Standard booth",
		DigitalIntelligenceEmpowersInnovativeEquipment:
			"Digital intelligence empowers innovative equipment",
		AuxiliaryProcessingSupporting: "Auxiliary processing supporting",
		GreenAndLowCarbonSolutions: "Green and low-carbon solutions",
		QualityCablesAndWires: "Quality cables and wires",
		PrecisionMeasurementAndControlTechnology:
			"Precision measurement and control technology",
		CompanyAddressLengthCannotBeLessThanXCharacters:
			"Company address length cannot be less than 10 characters",
		companyType1: "Wire and cable production and finishing machinery",
		companyType2: "Cable auxiliary machining",
		companyType3: "Raw and auxiliary materials for cables optical cables",
		companyType4: "Finished wire and wire cable",
		companyType5: "Measurement and control technology",
		companyType6: "Inspection engineering",
		companyType7: "Related field",
		nationalSingleChampion: "National Manufacturing Single Champion Enterprise",
		nationalGiant: "National \"Little Giant\" Specialized and Innovative Enterprise",
		specializedSme: "Specialized and Innovative SME",
		innovativeSme: "Innovative SME",
	},
	Exhibit: {
		AddExhibitInformation: "Product Presentation",
		EditExhibitInformation: "Edit exhibit information",
		ExhibitDetails: "Product Details",
		ExhibitNameCn: "Product Name (Chinese)",
		ExhibitNameEn: "Product Name (English)",
		ExhibitCategory: "Product Category",
		ExhibitPictures: "Product Pictures",
		CategoryTags: "Product Picture",
		ExhibitsCategories: "Product Categories",
		CustomTags: "Application Area",
		VideoUpload: "Video upload (optional)",
		ExhibitIntroductionCn: "Product Introduction(Chinese)",
		ExhibitIntroductionEn: "Product Introduction(English)",
		AuditStatus: "Approval Status",
		WriteLyricsForMe: "Write lyrics for me",
		instructionManual:
			"Note: Please select your exhibit category. If the above categories do not cover your exhibits, please add your own entry.",
		ItIsRecommendedToAddWatermark:
			"It is recommended to add a watermark when uploading exhibit photos",
		OnlyVideosInMp4FormatCanBeUploaded:
			"Only videos in mp4 format can be uploaded",
	},
	Apply: {
		AddPromotionalInformation: "Add Press Release",
		AddExhibitorsPromotionalInformation:
			"Add Exhibitors Promotional Information",
		EditExhibitorsPromotionalInformation:
			"Edit Exhibitors Promotional Information",
		ExhibitorPromotionApplicationDetails:
			"Exhibitor Promotion Application Details",
		ManuscriptWordCount:
			"*The manuscript should be 800-1200 words. It is recommended to provide company profile/product introduction/case sharing/technical introduction and other manuscript contents. 4-6 pictures, each picture should be less than 2M. It is recommended to add watermarks when uploading product pictures.",
		TitleCn: "Title(Chinese)",
		TitleEn: "Title(English)",
		CoverImage: "Cover Image",
		ContentCn: "Content(Chinese)",
		ContentEn: "Content(English)",
		File: "File",
	},
	Service: {
		ExhibitorServices: "Exhibition guide",
		BuildingServices: "All exhibitors submit",
		PublicityServices: "Standard booth exhibitor",
		ShipmentService: "Light and standard change exhibitors",
		OtherService: "Other optional services",
		TransportService: "Transport service",
		SubmissionDeadline: "Submission Deadline",
		TableType: "Table Type",
		FeedbackContact: "Feedback Contact",
		Title: "Title",
		Require: "Require",
	},
	OnlineInvite: {
		MobileInvitation: "Mobile Invitation",
		WeChatInvitationLetterGenerationSteps:
			"WeChat invitation letter generation steps",
		FillInCompanyInformation: 'Fill in "Company Information"',
		Completed: "Completed",
		Selected: "Selected",
		UploadExhibitInformation: "Select template",
		PleaseSelectOne: "Please select one of the invitation templates",
		GenerateCustomized: "Generate a customized \"WeChat invitation letter\"",
		ScanTheQRCodeBelow: "Scan the QR code below or copy the link",
		YouCanBrowseYourInvitationPageOnline:
			"Please use WeChat to scan the QR code above or copy the link below to WeChat. You can browse your invitation page online. Remember to forward and share~",
		KindTips:
			"Tips: In order to better promote the exhibitors, the organizer will invite your high-quality customers in the name of the exhibitors. If you need to invite high-quality customers, please fill in the following form. Invited customers will receive the following benefits:",
		KindTips1: "1、 Rapid on-site license renewal;",
		KindTips2:
			"2、Quickly obtain the exhibition information of the invited units;",
		KindTips3: "3、Free exhibition catalogue;",
		KindTips4: "4、A beautiful gift for the audience.",
		AddBatchAddEmailInvitations: "Add/batch add email invitations",
		Invited: "Invited",
		WaitingInvitation: "Waiting for invitation",
		PosterStylePreview: "Poster Style Preview",
		DownloadPoster: "Download poster",
		Name: "Name",
		CompanyName: "Company Name",
		Position: "Work Position",
		InvitationStatus: "Invitation Status",
	},
	ExhibitorCard: {
		KindTips: "The organizer will only provide exhibitor badges to exhibitors.",
		KindTips1:
			"• Exhibitors are required to provide the Passport No./HK&Macao Passes/Taiwan Identity for onsite verification.",
		KindTips2:
			'• Exhibitors can pick up exhibitor badges at the exhibitor registration office during the installation period.',
		TheIssuanceStandardsAreAsFollows:
			"• Exhibitor badges are issued based on stand areas:",
		IssuanceStandards1: "·9 square meters standard booth 3 exhibition badges",
		IssuanceStandards2: "·10m²-18m² 5 exhibitor passes",
		IssuanceStandards3: "·19m²-36m² 8 exhibitor badges",
		IssuanceStandards4: "·37m²-54m² 12 exhibitor badges",
		IssuanceStandards5: "·55m² - 72m² 16 exhibitor badges",
		IssuanceStandards6: "·73m² - 107m² 20 exhibitor badges",
		IssuanceStandards7: "·Each exhibitor will have a maximum of 25 badges.",
		OnlineRegistrationForExhibitorsHasClosed:
			"Online submission for exhibitor badges is now closed. For any changes or additions, please inform our staff onsite at the registration desk.",
		AddExhibitorBadge: "Add Exhibitor Badge",
		EditExhibitorBadge: "Edit Exhibitor Badge",
		ExhibitorBadgeDetails: "Exhibitor Badge Details",
		Name: "Name",
		CardType: "Identity Type",
		IdCardNo: "ID/ Passport/ HK & Macao Passes/ Taiwan Identity No.",
		Identity: "ID Card",
		Passport: "Passport",
		CardImage: "Card Photo",
		Other: "Passport/ HK & Macao Passes/ Taiwan Identity",
		IDCardPassport: "ID card/passport",
		CompanyName: "Company Name",
		Position: "Job Title",
		PhoneNumber: "Phone number",
		InvalidBoothArea: "Invalid booth area",
		CannotAddMoreExhibitorBadges: "Cannot add more exhibitor badges",
		OnlyDataThatFailedTheReviewCanBeEdited:
			"Only data that failed the review can be edited",
	},
	ExhibitorServiceManual: {
		PleaseEnter: "Please enter ",
		ExhibitorBadgeApplication: "Exhibitor Badge Application",
	},
	AdvertisingService: {
		AddAdvertisingServices: "Add Advertising Services",
		EditAdvertisingServices: "Edit Advertising Services",
		AdvertisingServiceDetails: "Advertising Service Details",
	},
	Pairing: {
		DemandInformationThatMayInterestYou:
			"Demand information that may interest you",
		BuyersFrom: "Buyers from foreign countries",
		MyPairingList: "Matchmaking List",
		Paired: "Paired",
		AwaitingReview: "Awaiting review",
		SuccessfulAudit: "Successful audit",
		Source: "Source",
		ProcurementRequirements: "Procurement Requirements",
		ReleaseDate: "Release Date",
		SerialNumber: "Serial number",
		MyMatchmakingApplication: "Matchmaking Management",
		ApplicationTime: "Application Time",
	},
	Consult: {
		ConsultMy: "Consult My",
		MyConsultation: "My Consultation",
	},
	AuditStatus: {
		Status: "Status",
		All: "All",
		UnderReview: "Under Review",
		AuditPassed: "Audit Passed",
		AuditFailure: "Audit Failure",
		Unanswered: "Unanswered",
		Replied: "Replied",
		Closed: "Closed",
		AuditFailureSubmit:"Review failed, resubmit"
	},
	custom: {
		offdate: "days ago",
		novalidCoupons: "No valid coupons",
		notFilled: "Please fill in the content",
		SignUpTips: "Successful registration",
		ScanQRCode: "Scan code reservation",
		SignUp: "Register Online",
		ExhibitRecommendation: "Exhibit Recommendation",
		ExhibitorRecommendation: "Exhibitor Recommendation",
		PopularVideosAndLiveStreams: "Popular Videos&Live Streams",
		FeaturedExhibits: "Featured Exhibits",
		HallSearch: "Hall Search",
		PleaseEnterTitle: "Please enter title",
		PleaseEnterIntroduction: "Please enter introduction",
		PleaseUploadCoverImage: "Please upload cover image",
		PleaseEnterTheContent: "Please enter the content",
		CannotEditDataUnderReview: "Cannot edit data under review",
		ApprovedDataCannotBeEdited: "Approved data cannot be edited",
		sm: "Please download the required documents and submit the completed forms to the designated supplier. For any inquiries, feel free to contact: chrys.qian@mds.cn",
		hk: "The basic Catalogue information is consistent with the booth application form. Please click 'Edit' to modify the information and fill in the company introduction before July 15, 2026. If you have any questions, please contact alex.gu@mds.cn",
		Title: "Title",
		CoverImage: "Cover Image",
		BriefIntroduction: "Brief Introduction",
		Content: "Content",
		ReleaseTime: "Release Time",
		Action: "Action",
		ConferenceJournalTips:
			"The information filled in will be used for the official exhibition website and WeChat promotion channels. The on-site information display collection for specialized and innovative enterprises has stopped, but you can continue to submit information online.",
		ConferenceJournalSuggestAddingWatermark:
			"Uploading product photos suggests adding a watermark",
		State: "State",
		All: "All",
		UnderReview: "Under review",
		ExaminationPassed: "Examination passed",
		AuditFailure: "Audit failure",
		AddedConferenceInformation: "Added conference information",
		EditingConferenceInformation: "Editing conference information",
		ViewConferenceInformation: "View conference information",
		EditSuccess: "Edit Success",
		Submit: "Submit",
		imageSizePoint:
			"The recommended size is 200px*100px. Supported formats are jpg and png.",
		TheCoverImageIsForOnlineAdvertisingPurposesOnly:
			"Click to upload the cover image, the cover image is only for online promotion. The recommended size is 200px x 100px. jpg and png formats are supported",
		imageSizeAlert: "You can only upload images in jpg or png format",
		dataLoadFailed: "Data loading failed, please try again later",
		singleUploadAlert: "Only 1 file can be uploaded",
		BackToList: "Back to list",
		Upload: "Upload",
		Reset: "Reset",
		Edit: "Edit",
		Check: "Check",
		Delete: "Delete",
		DeleteTitle: "Are you sure delete?",
		Yes: "Yes",
		No: "No",
		SuccessfullyDeleted: "successfully deleted",
		EnterTheContentYouNeedToSearch:
			"Please enter the content you need to search",
		Supplier: "Supplier",
		Product: "Product",
		SeeMore: "see more",
		BuyerPurchasingNeeds: "Buyer purchasing needs",
		PopularVideosAndLiveBroadcasts: "Popular Videos & Live Broadcasts",
		PlaceOfUse: "place of use",
		DateOfUse: "Date of Use",
		TheInformationProvidedWillBeUsedTo:
			"*The information provided will be used on the official website of the exhibition, or on the official WeChat account of the exhibition.",
		AddNewDemandInformation: "Add new demand information",
		PleaseReferToTheOnSiteAnnouncement:
			"*The above agenda is subject to change without prior notice. Please refer to the on-site announcement for details.",
		Time: "Time",
		Topic: "Activity",
		Speaker: "Remark",
		ThemeName: "Theme Name",
		Venue: "Venue",
		LiveBroadcastPreviewPreviousEpisodes:
			"Live broadcast preview | Previous episodes",
		GetTheVideoViewingLink: "Add contact WeChat to get video viewing link",
		CableCloudConsulting: "Cable Cloud Consulting",
		CableCloudPreviousEpisodes1:
			"2023 Issue 01 - Discussion on the innovation trend of green and low-carbon cable materials",
		CableCloudPreviousEpisodes2:
			"2023 Issue 02 - Discussion on the Trend of Simulation Technology in Cable R&D",
		CableCloudPreviousEpisodes3:
			"2023 Issue 03 - Discussion on the innovation trend of intelligent manufacturing and cable equipment",
		CableCloudPreviousEpisodes4:
			"2023 Issue 04 - Application and Trend Research of Computer-Aided Design Software for Wires and Cables",
		CableCloudPrevContactUsCompany: "Shanghai Electric Cable Research Institute Co. Ltd.",
		CableCloudPrevContactUsTitle: "Information Exhibition Center",
		CableCloudPrevContactUsName: "Mr. Liu Jianwei",
		CableCloudPrevContactUsPhone: "Tel: 18817395216",
		CableCloudPrevContactUsEmail: "charles@secri.com",
		ExhibitionNotice: "Overseas Exhibition",
		RecentActivities: "Exhibition Notice",
		Location: "location",
		ExhibitionVisitConsultation: "Exhibition/Visit Consultation",
		ExhibitionLocation1: "Mumbai, India",
		ExhibitionLocation2: "Monterrey, Mexico",
		ExhibitionLocation3: "Istanbul, Türkiye",
		ExhibitionLocation4: "Cairo, Egypt",
		ExhibitionLocation5: "Düsseldorf, Germany",
		ExhibitionLocation6: "Riyadh, Saudi Arabia",
		ExhibitionLocation7: "Bangkok, Thailand",
		ExhibitionLocation8: "Düsseldorf, Germany",
		SharedURLCopied: "Shared URL copied",
		YouHaveAlreadyCollected: "You have already collected",
		ConfirmSubmission: "Confirm Submission",
		Cancel: "Cancel",
		ThereIsAProblemAccessingTheAddress:
			"There is a problem accessing the address",
		NoMore: "No more than 200 words",
		NoData: "NoData",
		IHaveAlsoReadAndAgreed: "I have also read and agreed",
		PrivacyPolicyStatement: "Privacy Policy Statement",
		AgreeToTheCollectionAndUseOfPersonalData:
			"And agree to the collection and use of my personal data as outlined in this statement.",
		PleaseReadAndAgreeToThePrivacyPolicyStatementFirst:
			'Please read and agree to the "Privacy Policy Statement" first',
		PleaseEnter: "Please enter {value}",
		PleaseChoose: "Please choose {value}",
		MaxLength: "{value} cannot exceed {length} characters",
		PleaseUpload: "Please upload {value}",
		UploadFiles: "Upload Files",
		RecommendedSize: "Recommended Size",
		TheFileSizeCannotExceed: "The file size cannot exceed",
		TaxID: "Tax ID",
		Save: "Save",
		Email: "Email",
		Completed: "Completed",
		Undone: "Undone",
		FillInOnline: "Fill In Online",
		Uploaded: "Uploaded",
		Download: "Download",
		NoFileWasFoundToDownload: "No file was found to download",
		CheckDetails: "Check details",
		PleaseLogin: "Please Login",
		Phone: "Email",
		PhonePlaceholder: "Please enter the Email number",
		PhoneCodePlaceholder:
			"Please enter your correct Email number to get the verification code",
		VisitorCenterAccount:
			"This Email number will be used as your account to log in to the Visitor Center",
		CgtCenterAccount: "This Email number will be used as your account to log in to the Visitor Group Center",
		VerificationCode: "Verification Code",
		VerificationCodePlaceholder: "please enter verification code",
		ResendVerificationCode: "Resend after {value}s",
		GetVerificationCode: "Get Verification Code",
		CapturingDownloadingImages: "Capturing and downloading images:",
		FillOutTheAudienceQuestionnaire:
			"Pop-up window prompts you to fill in the audience questionnaire",
		SMSVerificationCodeSentSuccessfully:
			"SMS verification code sent successfully",
		EmailVerificationCodeSentSuccessfully:
			"Email verification code sent successfully",
		isRequire: "required",
		notRequire: "optional",
	},
	subscribeDialog: {
		title: "Subscribe to Spreadtrum",
		label1: "I am",
		holder1: "Please select identity",
		label2: "Company",
		holder2: "Please enter company name",
		label3: "Name",
		holder3: "Please enter your name",
		label4: "Mailbox",
		holder4: "Please enter email",
		btn1: "Confirm submission",
		btn2: "Cancel",
	},
	template1: "template 1",
	template2: "template 2",
	template3: "template 3",
	changePsw: {
		btn: " Confirm",
		label1: "Old Password",
		holder1: "Please enter old password",
		label2: "New Password",
		holder2: "Please enter a new password",
		label3: "Confirm new password",
		holder3: "Please enter your new password again",
		holder4: "Two password inconsistencies",
	},
	journal: {
		companyCn: "Company name in Chinese",
		companyCnHolder: "Please enter company name",
		companyEn: "Company name in English",
		companyEnHolder: "Please enter company name in English",
		companyAddress: "Company address",
		companyAddressHolder: "Please enter the company address",
		phone: "Company phone",
		phoneHolder: "Please enter company number",
		fax: "Company Fax",
		faxHolder: "Please enter company fax",
		webSite: "Company website",
		webSiteHolder: "Please enter company URL",
		contentCn: "Company Introduction in Chinese",
		contentCnMaxLength: "Chinese introduction cannot exceed 105 characters",
		contentEnMaxLength: "English introduction cannot exceed 220 characters",
		contentCnHolder: "Please enter Chinese description",
		contentEn: "Company Introduction in English",
		contentEnHolder: "Please enter English description",
		classify: "Main Product Categories",
		classifyHolder: "Please select Product Category code",
		submit: "Submit",
	},

	adType: "Ad Type",
	adType1: "Onsite advertising",
	adType2: "Print Advertisement",
	adType3: "Online Promotional Advertisement",
	add: "New",
	name: "Name",
	description: "Description",
	saleOut: "Is sale",
	Y: "Yes",
	N: "No",
	price: "Price",
	unit: "Unit",
	buyAmount: "Amount",
	attachment: "Attachment",
	createTime: "Creation time",
	auditState: "Audit status",
	auditState1: "Under review",
	auditState2: "Passed",
	auditState3: "Rejected",
	copySuccess: "Copy successful",
	toRegister: "Please register to be a spectator",
	tokenFailed: "The user is invalid. Please log in again",
	publishType: {
		urgentNeed: "Urgent need",
		oneoffDemand: "One-off demand",
		periodiclongtermNeed: "Periodic/long-term needs",
	},
	searchInputEmpty: "Please enter what you want to search for",
	searchNodata: "No search results",
	search: {
		includesStarter: "Includes\"",
		includesEnder: "\"search results for keywords",
		typeCompany: "Exhibitor",
		typeEntry: "Exhibit",
		typePurchase: "Purchase info",
		typeDynamic: "Exhibition dynamics",
		typeExhibitor: "Exhibitor list",
		typeFile: "Exhibition materials",
		detail: "View details",
	},
	groupRegister: {
		natureEnterprise: "Enterprise",
		natureGovernment: "Government",
		natureAssociation: "Association",
		natureSchool: "School",
		natureOther: "Other",
		groupName: "Group Name",
		groupNamePlaceholder: "Please enter group name",
		nature: "Nature of Group",
		naturePlaceholder: "Please enter group nature",
		expectedCount: "Expected number of participants",
		expectedCountPlaceholder: "Please enter expected number of participants",
		backup: "Remarks",
		backupPlaceholder: "Up to 200 characters",
		contactPerson: "Contact Person",
		contactPhone: "Contact Person Phone",
		contactEmail: "Contact Person Email",
		teamApplyTitle: 'Group Visit Application',
		teamApplyTips: 'Tips',
		teamApplyDesc: 'You are applying to create a new group visit. After successful creation, you will serve as the contact person for this group and will be able to manage team members and application information.',
		currentUserInfo: 'Current User Information',
		groupNameLength: 'Group name must be between 2 and 50 characters',
		expectedCountRange: 'Expected number of participants should be between 1 and 1000',
		backupMaxLength: 'Remarks cannot exceed 500 characters',
		submitApply: 'Submit Application',
		cancel: 'Cancel',
		groupNameTips: 'Please enter the official name of the visiting group. It is recommended to use the full name of the organization',
		expectedCountTips: 'Please fill in according to the actual situation. This can be modified later',
		backupTips: 'If there are special requests or notes, please enter them here',
		otherInfoTitle: 'Additional Information Description',
		otherInfoDesc: 'Additional information such as banners, buses, etc., can be added and improved in the group visit management page after the group is created.',
		loginRequired: 'Please log in first',
		loadUserInfoFailed: 'Failed to load user information',
		applySuccess: 'Group visit application submitted successfully',
		applyFailed: 'Application submission failed. Please try again later',
		noGroupTitle: 'You have no tour group',
		noGroupDesc: 'You have not created or joined any tour group. Please create or apply to join a tour group first',
		createGroupBtn: 'Apply for Tour Group',
		noGroupWarn: 'Please create or join a tour group first to use this feature',
		title:"Visitor Group Registration",
		contactStep:"Verificate",
		successStep:"Complete",
		groupInfoStep:"Write",
		questionStep:"Question",
		groupNature:"Group nature",
		goToGroupCenter:"Go to Group Center",
		groupCode:"Group code",
		successTitle:"Successfully registered",
	},
	common: {
		ok: "OK",
		cancel: "Cancel",
		confirm: "Confirm"
	},
	groupCenter: {
		ok:"OK",
		cancel:"Cancel",
		nameLength:"Name cannot exceed 50 characters",
		batchDeleteErrorLog: "Batch delete failed:",
		deleteFailed: "Delete failed",
		deleteErrorLog: "Delete member failed:",
		email: "Email",
		nameLengthError: "Name cannot exceed 50 characters",
		companyLengthError: "Company name cannot exceed 100 characters",
		loadMemberFailed: "Failed to load member list",
		confirmDelete: "Confirm Delete",
		batchDeleteConfirm: "Are you sure you want to delete {count} selected members?",
		deleteConfirm: "Are you sure you want to delete member {name}?",
		deleteSuccess: "Delete successful",
		selectMember: "Please select members to delete",
		operationFailed: "Operation failed",
		editSuccess: "Edit successful",
		memberid:"ID number",
		idNumberRequired:"Please enter ID number",
		error:"Error",
		genxinerror:"Information update failed",
		genxinsuccess:"Information updated successfully",
		ren:"people",
		editGroupModaltitle: "Edit Group Information",
		idNumberFormat:"ID card number format error",
		editMember:"Edit team member information",
		importSuccess:"Import successful",
		phoneRequired: "Please enter team member contact information",
		companyRequired: "Please enter team member ID card number",
		nameRequired: "Please enter team member name",
		delete: "Delete",
		edit: "Edit",
		addSuccess: "Added successfully",
		action: "Action",
		phoneFormat: "Invalid contact format",
		downloadTemplate: "Download Template",
		importBtn: "Import",
		noFileSelected: "No file selected",
		selectFile: "Please select a file",
		addMemberBtn: "Add Member",
		back: "Return to Group Center Home",
		memberManage: "Team Member Management",
		batchDelete: "Batch Delete",
		batchImportDesc: "Only Excel file uploads are supported. Please download the template and fill it out according to the required format. Do not modify the Audience Group ID.",
		batchImport: "Batch Import Team Members",
		searchPlaceholder: "Please enter team member keyword",
		phonePlaceholder: "Please enter team member contact information",
		companyPlaceholder: "Please enter team member Company",
		namePlaceholder: "Please enter team member name",
		memberCompany: "member Company",
		idNumber:"idNumber",
		memberPhone: "Phone Number",
		memberMail: "Email",
		memberName: "Name",
		idNumberPlaceholder:"Please enter ID number",
		mailPlaceholder:"Please enter email",
		addMember: "Add Team Member",
		createTime: "Creation Time",
		groupName: "Group Name",
		editGroup: "Edit Group Information",
		refresh: "Refresh Group Information",
		noGroupTitle: 'You have no visiting group yet',
		noGroupDesc: 'You have not created or joined any visiting group. Please create or apply to join a group first.',
		createGroupBtn: 'Apply for Visiting Group',
		noGroupWarn: 'Please create or join a group first to use this function',
		title: "Group Center",
		menuLabel1: "Home",
		menuLabel2: "Visit Registration",
		menuLabel2Item1: "Electronic Group Visit Pass",
		menuLabel2Item2: "Group Visit Benefits",
		menuLabel2Item4: "Group Questionnaire",
		menuLabel3: "Team Services",
		menuLabel3Item1: "Add Team Member",
		menuLabel3Item2: "Member Management",
		menuLabel3Item3: "Invite Friends to Register",
		menuLabel4: "Procurement Services",
		menuLabel4Item1: "My Published Procurement Needs",
		menuLabel4Item2: "My Inquiries",
		menuLabel4Item3: "Favorites - Suppliers & Products",
		menuLabel5: "Meetings & Events",
		menuLabel6: "Contact Us",
		menuLabel7: "Group Management",
		menuLabel7Item1: "Rights Modification",
		menuLabel7Item2: "Team Member Management",
		label7: "The pre-registration portal for Audience Groups will close at 12:00 (Beijing Time) on August 26, 2026. Please be advised.",
		footerTitle: "Log Out",
		label1: "Dear ",
		label2: "Welcome to the Audience Group Center",
		label3: "You can manage your visiting group and related services here",
		groupInfo: "Group Information",
		groupCode: "Group Code",
		memberCount: "Number of Members",
		groupInstructions: "Group Visit Instructions",
		instruction1: "Group visits require unified entry. Please assemble at the designated location 15 minutes in advance.",
		instruction2: "The group leader must bring valid identification and the group visit pass.",
		instruction3: "Each team member must bring their personal valid identification.",
		instruction4: "Group Visit Notes",
		instruction5: "Please follow on-site exhibition order and maintain a neat group formation.",
		instruction6: "For special requirements, please contact exhibition staff in advance.",
		contactInfo: "Contact Information",
		successMessage3: "Your group visit pass has been generated. Please keep it safe.",
		douhao: ", ",
		maohao: ": ",
		downloadCard: "Download Visit Pass",
		manageMembers: "Manage Team Members",
		cardContent1: "Electronic Group Visit Pass",
		cardContent2: "Group Visit Benefits",
		cardContent3: "Publish Procurement Needs",
		cardContent4: "Supplier & Product Favorites",
		cardContent5: "Apply for Group Visit Services",
		cardContent6: "Meetings & Events",
		cardContent7: "Team Member Management",
		hoverContent1: "View and download your electronic group visit pass",
		hoverContent2: "View the various benefits available for group visits",
		hoverContent3: "Publish your procurement needs and find suitable suppliers",
		hoverContent4: "Save suppliers and products of interest",
		hoverContent5: "Apply for services related to group visits",
		hoverContent6: "View and register for relevant meetings and events",
		hoverContent7: "Manage your team member information",
		groupNature: "Group Nature",
		modal: {
			title: "Reminder",
			content: "You have not completed the group questionnaire. Would you like to complete it now?",
			btn: "Go to Complete"
		}
	},
	groupBenefits: {
		duplicateSubmission: "Please don't resubmit your application. The system is processing it.",
		conditionNotMet: "Unmet Application Conditions",
		back: "Back",
		benefitRules: "Group Benefit Application Rules",
		rule1: "Groups with 10 or more members can apply for a banner",
		rule2: "Groups with 30 or more members can apply for meal vouchers",
		rule3: "Groups with 30 or more members and a pickup location within 30 km of the venue can apply for free shuttle bus service",
		currentMembers: "Current Number of Group Members",
		lastUpdate: "Last Updated",
		applyFormTitle: "Group Benefit Application",
		bannerLabel: "Banner Application",
		available: "Available",
		unavailable: "Unavailable",
		conditionallyAvailable: "Conditionally Available",
		bannerContent: "Banner Content",
		bannerContentRequired: "Please enter banner content",
		bannerContentMaxLength: "Banner content cannot exceed 50 characters",
		bannerContentPlaceholder: "Please enter banner content (max 50 characters)",
		bannerRequirement: "Requires {count} or more members to apply",
		ticketLabel: "Meal Voucher Application",
		ticketCount: "Number of Meal Vouchers",
		ticketCountPlaceholder: "Please enter the number of meal vouchers",
		ticketCountMin: "Number of meal vouchers cannot be negative",
		ticketCountMax: "Number of meal vouchers cannot exceed the number of members (max {count})",
		ticketRequirement: "Requires {count} or more members to apply",
		busLabel: "Shuttle Bus Application",
		distanceKm: "Distance in Kilometers",
		distancePlaceholder: "Please enter the distance from the venue in kilometers",
		distanceMin: "Distance cannot be negative",
		distanceWithinLimit: "Distance is within 300 km and meets the application requirements",
		distanceExceedLimit: "Distance exceeds 300 km and does not meet the application requirements",
		busCount: "Number of Buses",
		busCountPlaceholder: "Please enter the number of buses",
		busCountRequired: "Please enter the number of buses",
		busCountMin: "At least 1 bus is required",
		busCountMax: "Maximum number of buses is 10",
		busRequirement: "Requires {count} or more members and a distance within 300 km of the venue to apply",
		pickupLocation: "Pickup Location",
		pickupLocationPlaceholder: "Please enter the pickup location (e.g., Hotel entrance)",
		pickupLocationMaxLength: "Pickup location cannot exceed 100 characters",
		dropoffLocation: "Drop-off Location",
		dropoffLocationPlaceholder: "Please enter the drop-off location (e.g., Main entrance of the venue)",
		dropoffLocationMaxLength: "Drop-off location cannot exceed 100 characters",
		locationInfo: "Pickup Information",
		remark: "Remarks",
		remarkPlaceholder: "Please enter any additional notes or requirements",
		currentBenefits: "Currently Applied Benefits",
		banner: "Banner",
		ticket: "Meal Vouchers",
		bus: "Shuttle Bus",
		noBenefits: "No benefits have been applied for yet",
		cancel: "Cancel",
		submit: "Submit Application",
		selectAtLeastOne: "Please fill in at least one benefit",
		"applySuccess": "Application submitted successfully",
		"bannerApplied": "Banner application submitted",
		"ticketApplied": "Meal voucher application submitted ({count} vouchers)",
		"busApplied": "Shuttle bus application submitted ({count} buses, distance {distance} km)",
		"applyFailed": "Application submission failed. Please try again later",
		"loadDataFailed": "Failed to load data",
		"unitPerson": "pcs",
		"unitKm": "km",
		"unitVehicle": "vehicles",
		"busDistanceWarning": "Distance exceeding 300 km from the venue does not meet the free shuttle bus application requirement",
		"ticketAppliedDesc": "Meal vouchers applied for",
		"busAppliedDesc": "Shuttle bus applied for",
		"distance": "Distance",
		"contactStaff": "Staff will contact you shortly to confirm the application details"
	},
};
